/* ============================================
   QUOTE WORKSTATION — Save
   Asset: workstation-save.js
   Save, send, PDF preview, validation, and CFA list
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;
  var state = Q.state;
  var dom = Q.dom;
  var wrap = Q.wrap;
  var API = Q.API;
  var isAdmin = Q.isAdmin;
  var showToast = Q.showToast;
  var fmt = Q.fmt;
  var parseMoney = Q.parseMoney;
  var syncCustomSelect = Q.syncCustomSelect;

  /* CUSTOM_OFFLINETAXROW_BY_CLAUDE (Ryan 2026-10-30) - a save's offlineTax (Shopify's tax on an offline permit-state deal) onto the
     Tax row and total (workstation-totals.js). Called before each save takes its saved-total snapshot; keeps the dirty flag as it was,
     because recalcTotals marks the quote dirty. */
  function takeOfflineTax(data) {
    state.offlineTax = (data && data.offlineTax) || null;
    if (data && data.taxPlan) state.taxPlan = data.taxPlan; // CUSTOM_AUTOTAX_BY_CLAUDE - the rate box's "0% WY" / "Add address"
    var wasDirty = state.dirty;
    if (Q.recalcTotals) Q.recalcTotals();
    state.dirty = wasDirty;
  }

  /* ── Send Settings Sync ── */
  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — the Shared Deal recipient box.
       BLOCK A (data-referral-block, under Deal Type) — the Shared Deal recipient
         you SHARE GP with: name + % of GP, the partner is PAID (shared band).
         Shown only when Deal Type = Shared Deal. state.referral = {name,gpPercent}.
     CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI decoupling piece 3) — BLOCK B
     ("Referred By", the unpaid relationship note that hung off Lead Source) was
     REMOVED with the Lead Source dropdown; who-referred-us on a non-shared deal
     goes in Notes now. A paid BLOCK A referral additionally suppresses ad
     attribution for the deal server-side (lib/referral-suppression.js). */
  var referralBlock = wrap.querySelector('[data-referral-block]');
  var referralNameEl = wrap.querySelector('input[data-field="referralName"]');
  var referralPctEl = wrap.querySelector('input[data-field="referralGpPercent"]');
  function updateReferralBlockVisibility() {
    var isShared = state.leadSource === 'shared';
    // BLOCK A — Shared Deal recipient (name + % of GP, paid).
    if (referralBlock) {
      referralBlock.classList.toggle('rq-ws-referral--open', isShared);
      if (!isShared) {
        state.referral = { name: '', gpPercent: 0 };
        if (referralNameEl) referralNameEl.value = '';
        if (referralPctEl) referralPctEl.value = '';
      }
    }
  }
  Q.updateReferralBlockVisibility = updateReferralBlockVisibility;
  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Hydrate the referral-name datalist from
     localStorage memory so prior names autocomplete as admin types. Shared
     key `bsfs_referral_memory` with the Quote Dashboard's +New lead form
     so both surfaces stay in sync. */
  (function hydrateReferralMemory() {
    try {
      var dl = wrap.querySelector('#rq-ws-referral-name-memory');
      if (!dl) return;
      var mem = JSON.parse(localStorage.getItem('bsfs_referral_memory') || '[]') || [];
      if (!Array.isArray(mem)) return;
      mem.forEach(function(m) {
        if (m && m.name) {
          var opt = document.createElement('option');
          opt.value = m.name;
          dl.appendChild(opt);
        }
      });
    } catch (_) { /* localStorage disabled — typing still works, just no autocomplete */ }
  })();
  function pushReferralToMemory(name, gpPercent) {
    try {
      if (!name) return;
      var mem = JSON.parse(localStorage.getItem('bsfs_referral_memory') || '[]') || [];
      if (!Array.isArray(mem)) mem = [];
      var key = String(name).trim().toLowerCase();
      if (!key) return;
      mem = mem.filter(function(m) { return m && m.name && String(m.name).toLowerCase() !== key; });
      mem.unshift({ name: String(name).trim(), gpPercent: parseFloat(gpPercent) || 0, lastUsedAt: new Date().toISOString() });
      if (mem.length > 50) mem = mem.slice(0, 50);
      localStorage.setItem('bsfs_referral_memory', JSON.stringify(mem));
    } catch (_) { /* non-fatal */ }
  }
  Q._pushReferralToMemory = pushReferralToMemory;
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  if (referralNameEl) {
    referralNameEl.addEventListener('input', function() {
      state.referral = state.referral || { name: '', gpPercent: 0 };
      state.referral.name = this.value || '';
      state.dirty = true;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Recalc so Commission Breakdown
         live-updates: the panel only labels Commission with the recipient
         name (and uses the custom %) when BOTH name + gpPercent are set. */
      Q.recalcTotals();
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    });
  }
  if (referralPctEl) {
    referralPctEl.addEventListener('input', function() {
      state.referral = state.referral || { name: '', gpPercent: 0 };
      state.referral.gpPercent = parseFloat(this.value) || 0;
      state.dirty = true;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Recalc so the Commission Rate +
         amount + out-of-band red warning all reflect the new %
         immediately as admin types. */
      Q.recalcTotals();
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    });
  }
  /* CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI decoupling piece 3) — the Lead Source
     dropdown, its inbound-required gating (syncInquirySourceState) and the Referred By
     input handler were REMOVED. They existed to let a rep classify the marketing origin of
     a deal; origin is now derived server-side from hard signals (rfq-worker
     lib/lead-signals.js). Q.syncInquirySourceState is kept as a no-op because the boot /
     quote-load / reset paths call it. */
  Q.syncInquirySourceState = function () {};

  var leadSourceEl = wrap.querySelector('select[data-field="leadSource"]');
  if (leadSourceEl) leadSourceEl.addEventListener('change', function() {
    state.leadSource = this.value;
    state.dirty = true;
    // Deal Type drives whether the Shared Deal recipient block (BLOCK A) shows. It is a pure
    // COMMISSION field now — it no longer influences marketing attribution in any way.
    updateReferralBlockVisibility();
    Q.recalcTotals();
  });

  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Per-quote "add website links to products on
     the PDF" toggle. Persists to workstation_meta.linkProductsOnPdf. */
  var linkProductsEl = wrap.querySelector('[data-field="linkProductsOnPdf"]');
  if (linkProductsEl) linkProductsEl.addEventListener('change', function() {
    state.linkProductsOnPdf = this.checked;
    state.dirty = true;
    // Re-render rows so the per-item link controls appear/disappear, and load
    // any saved external links for the current items when turning it on.
    if (Q.renderItems) Q.renderItems();
    if (this.checked && Q.fetchExternalLinks) Q.fetchExternalLinks();
  });

  /* CUSTOM_ROOMDESIGNER_BY_CLAUDE — Per-quote "add gym layout to PDF" toggle.
     Persists to workstation_meta.includeLayoutInPdf; the worker
     (pdf/layout-append.js) appends one page per layout space to the quote PDF. */
  var layoutPdfEl = wrap.querySelector('[data-field="includeLayoutInPdf"]');
  if (layoutPdfEl) layoutPdfEl.addEventListener('change', function() {
    state.includeLayoutInPdf = this.checked;
    state.dirty = true;
  });
  var layoutOverageEl = wrap.querySelector('[data-field="layoutOverage"]');
  if (layoutOverageEl) layoutOverageEl.addEventListener('change', function() {
    state.layoutOverage = this.checked;
    state.dirty = true;
  });
  var layoutDimsEl = wrap.querySelector('[data-field="layoutDimensions"]');
  if (layoutDimsEl) layoutDimsEl.addEventListener('change', function() {
    state.layoutDimensions = this.checked;
    state.dirty = true;
  });
  /* Reveal the toggle's field only when this quote has a linked floor plan
     (state.linkedFiles) or a pending design link from a GLD handoff. Called from
     loadQuote + the GLD-append boot. Forces the boxes off when no layout is
     linked so a stale-checked box can never ship an empty append. */
  /* CUSTOM_COMPOSEDRAFT_BY_CLAUDE (Ryan 2026-10-10) — "mark the quote sent" after an Outlook send, shared by the
     Send Quote composer and one reopened from a tab after a refresh. */
  Q.markQuoteSentFromComposer = function() {
    if (window.RepPortal && window.RepPortal.API) {
      window.RepPortal.API.post('/quote-mark-sent', { ref: state.ref }).catch(function() {});
    }
    state.dirty = false;
    document.dispatchEvent(new Event('rq-ws:saved'));
    if (Q.setStatusBadge) Q.setStatusBadge('sent');
  };
  /* A quote loaded: Send Quote wears "Draft" while a saved email waits, and a minimized one shows its tab. */
  Q.syncComposeDraft = function() {
    var b = wrap.querySelector('.rq-ws-send__send');
    if (b && state.ref) b.setAttribute('data-compose-draft-ref', state.ref);
    if (!window.RQD) return;
    if (window.RQD.showMinimizedDraft) window.RQD.showMinimizedDraft(state.ref, { onSent: Q.markQuoteSentFromComposer });
    if (window.RQD.refreshComposeDraftMarkers) window.RQD.refreshComposeDraftMarkers();
  };
  Q.refreshLayoutPdfToggle = function() {
    var field = wrap.querySelector('.rq-ws-layout-pdf-field');
    var box = wrap.querySelector('[data-field="includeLayoutInPdf"]');
    var ovBox = wrap.querySelector('[data-field="layoutOverage"]');
    var dimBox = wrap.querySelector('[data-field="layoutDimensions"]');
    var hasLayout = (Array.isArray(state.linkedFiles) && state.linkedFiles.some(function(f) { return f && f.type === 'floor-plan'; }))
      || !!state.pendingLinkDesign;
    if (field) field.style.display = hasLayout ? '' : 'none';
    if (!hasLayout) { state.includeLayoutInPdf = false; state.layoutOverage = false; state.layoutDimensions = false; }
    if (box) box.checked = hasLayout && !!state.includeLayoutInPdf;
    if (ovBox) ovBox.checked = hasLayout && !!state.layoutOverage;
    if (dimBox) dimBox.checked = hasLayout && !!state.layoutDimensions;
    if (Q.refreshLayoutSync) Q.refreshLayoutSync();
    if (Q.syncComposeDraft) Q.syncComposeDraft();
  };

  /* CUSTOM_QUOTELAYOUTCOPY_BY_CLAUDE + CUSTOM_QUOTELAYOUTSWAP_BY_CLAUDE (Ryan 2026-10-10, RW-1379-A/-B/-C)
     — the yellow line under Gym Layout. Two cases:
       1. this version has NO layout and another version of the deal does -> "Copy the gym layout from
          RW-1379-A" (POST /quote-copy-layout: this version gets its own copy of that design);
       2. this version HAS a layout and its flooring is no longer what the layout shows (a colour changed
          on a Save As copy) -> "Update the layout": opens this version's design in the designer, which
          swaps the colour and redraws the proposal pages (custom-room-designer-storage.js
          _maybeApplyFloorSwap). The design's own item list (planItems) is compared by SKU. */
  function _floorPlanOf(list) {
    return (Array.isArray(list) ? list : []).filter(function(f) { return f && f.type === 'floor-plan' && f.designId; })[0] || null;
  }
  function _syncEsc(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var _syncSeq = 0;
  Q.refreshLayoutSync = function() {
    var box = wrap.querySelector('.rq-ws-layout-sync');
    if (!box) return;
    var seq = ++_syncSeq;
    box.style.display = 'none'; box.innerHTML = '';
    if (!state.ref || state.pendingLinkDesign) return;
    var fp = _floorPlanOf(state.linkedFiles);
    if (!fp) {
      if (!/-[B-Z]$/.test(String(state.ref))) return;
      API.get('/quote-copy-layout?ref=' + encodeURIComponent(state.ref)).then(function(d) {
        if (seq !== _syncSeq || !d || !d.from) return;
        box.innerHTML = '<label class="rq-ws-field__label">Gym Layout</label>'
          + '<div class="rq-ws-layout-sync__body"><span class="rq-ws-layout-sync__text"><strong>No gym layout on this version.</strong> '
          + 'Its PDF has no layout page. ' + _syncEsc(d.from) + ' has one.</span>'
          + '<button type="button" class="rq-ws-layout-sync__btn rq-ws-layout-sync__copy">Copy layout from ' + _syncEsc(d.from) + '</button></div>';
        box.style.display = '';
        box.querySelector('.rq-ws-layout-sync__copy').addEventListener('click', function() {
          var btn = this; btn.disabled = true; btn.textContent = 'Copying...';
          API.post('/quote-copy-layout', { ref: state.ref, fromRef: d.from }).then(function(res) {
            if (!res || !res.copied) throw new Error((res && res.error) || 'Copy failed');
            state.linkedFiles = (Array.isArray(state.linkedFiles) ? state.linkedFiles : []).filter(function(f) { return !(f && f.type === 'floor-plan'); })
              .concat([{ type: 'floor-plan', designId: res.designId, designRef: res.designRef }]);
            var fl = res.layoutFlags || {};
            state.includeLayoutInPdf = !!fl.includeLayoutInPdf;
            state.layoutOverage = !!fl.layoutOverage;
            state.layoutDimensions = !!fl.layoutDimensions;
            showToast('Copied the gym layout from ' + d.from + ' as ' + res.designRef + '.', 'success');
            Q.refreshLayoutPdfToggle();
          }).catch(function(err) {
            btn.disabled = false; btn.textContent = 'Copy layout from ' + d.from;
            showToast('Could not copy the layout: ' + (err && err.message || err), 'error');
          });
        });
      }).catch(function() {});
      return;
    }
    API.get('/design-items/' + encodeURIComponent(fp.designId)).then(function(d) {
      if (seq !== _syncSeq || !d || !d.planItems) return;
      var check = _layoutCheck(d, state.items || []);
      if (check.drawingInProgress) {
        _syncShow(box, '<span class="rq-ws-layout-sync__text">The layout was just saved. Its PDF pages are still being redrawn...</span>');
        setTimeout(function() { if (seq === _syncSeq) Q.refreshLayoutSync(); }, 10000);
        return;
      }
      /* ⛔ EACH QUOTE VERSION HAS ITS OWN PLAN (Ryan 2026-11-04, RW-1536-A/-B shared PLAN-1111-A: "Each version of quote
         should have it's own updated floor plan on it"). A plan another version also uses is never changed in place:
         this quote gets its own copy first (POST /quote-copy-layout, replace), and the change lands on the copy. The tab
         is opened inside the click, before the copy answers, or the browser blocks it as a popup. */
      var _sib = _sharedSibling(d);
      function _wireShared(btn) {
        btn.addEventListener('click', function(ev) {
          ev.preventDefault();
          btn.style.pointerEvents = 'none'; btn.textContent = 'Copying...';
          _splitAndOpen(_sib, check);
        });
      }
      var lines = _layoutLines(check);
      if (_sib && !check.autoNeeded && !check.flags.length) {
        _syncShow(box, '<span class="rq-ws-layout-sync__text"><strong>Layout check:</strong> This quote shares its plan with ' + _syncEsc(_sib) + ', so a change to one changes both.</span>'
          + '<a href="#" class="rq-ws-layout-sync__btn rq-ws-layout-sync__update">Give this quote its own plan</a>');
        _wireShared(box.querySelector('.rq-ws-layout-sync__update'));
        return;
      }
      if (!lines.length) return;
      _syncShow(box,
        '<span class="rq-ws-layout-sync__text"><strong>Layout check:</strong> ' + lines.map(_syncEsc).join(' ')
        + '<span class="rq-ws-layout-sync__note">' + (check.autoNeeded
          ? 'The button opens the layout, makes this change and redraws the PDF pages. Wait for the green banner there, then come back.'
          : 'Fix it in the layout and click Save there. This quote picks it up when you come back.') + '</span></span>'
        + '<a href="' + _layoutFixUrl(fp, state.ref, check) + '" target="_blank" rel="noopener" class="rq-ws-layout-sync__btn rq-ws-layout-sync__update">' + (check.autoNeeded ? 'Update layout' : 'Fix in layout') + '</a>');
      if (_sib && check.autoNeeded) _wireShared(box.querySelector('.rq-ws-layout-sync__update'));
    }).catch(function() {});
  };

  /* What the quote and its layout disagree on. Flooring by SKU (a colour of the same product is swapped
     automatically), equipment by SKU and count (gone from the quote = removed automatically; a count that
     differs = flagged, Ryan: the system cannot tell which piece you meant). Equipment on the quote but not
     on the layout is not knowable here (a quote line is not marked as equipment), so it is left alone. */
  function _layoutCheck(d, items) {
    var norm = function(v) { return String(v || '').trim().toUpperCase(); };
    var pi = d.planItems || {};
    var floors = Array.isArray(pi.flooring) ? pi.flooring : [];
    var equipment = Array.isArray(pi.equipment) ? pi.equipment : [];
    var designSkus = {};
    ['flooring', 'equipment', 'turf', 'platforms'].forEach(function(k) {
      (Array.isArray(pi[k]) ? pi[k] : []).forEach(function(f) { if (f && f.sku) designSkus[norm(f.sku)] = 1; });
    });
    var quoteQty = {};
    items.forEach(function(it) { if (it && it.sku) quoteQty[norm(it.sku)] = (quoteQty[norm(it.sku)] || 0) + (parseFloat(it.quantity) || 1); });
    var stale = floors.filter(function(f) { return f && f.sku && !quoteQty[norm(f.sku)]; });
    var fresh = items.filter(function(it) { return it && it.sku && !designSkus[norm(it.sku)]; });
    var swapFrom = (stale.length && fresh.length) ? stale.map(function(f) { return f.sku; }) : [];
    var swapTo = swapFrom.length ? fresh.map(function(it) { return it.sku; }) : [];
    var eqQty = {}, eqTitle = {};
    equipment.forEach(function(e) { if (!e || !e.sku) return; var k = norm(e.sku); eqQty[k] = (eqQty[k] || 0) + (parseFloat(e.qty) || 0); eqTitle[k] = e.title || e.sku; });
    var removeEq = [], flags = [];
    Object.keys(eqQty).forEach(function(k) {
      var q = quoteQty[k] || 0;
      if (!q) removeEq.push(k);
      else if (q !== eqQty[k]) flags.push('The layout shows ' + eqQty[k] + ' x ' + eqTitle[k] + ', the quote has ' + q + '.');
    });
    if (stale.length && !fresh.length) {
      flags.push('The layout shows ' + stale.map(function(f) { return (f.title || 'flooring') + (f.color ? ' (' + f.color + ')' : ''); }).join(', ') + ', which is not on this quote.');
    }
    var upd = Date.parse(d.designUpdatedAt || '') || 0;
    var drawn = Date.parse(d.variantsAt || '') || 0;
    var staleDrawing = !!(d.hasVariants && upd && drawn && upd - drawn > 2000);
    var drawingInProgress = staleDrawing && (Date.now() - upd < 3 * 60 * 1000);
    return {
      swapFrom: swapFrom, swapTo: swapTo, removeEq: removeEq, flags: flags,
      staleNames: stale.map(function(f) { return (f.title || 'flooring') + (f.color ? ' (' + f.color + ')' : ''); }),
      staleDrawing: staleDrawing, drawingInProgress: drawingInProgress,
      autoNeeded: !!(swapFrom.length || removeEq.length || staleDrawing),
    };
  }

  function _syncShow(box, inner) {
    box.innerHTML = '<div class="rq-ws-layout-sync__body">' + inner + '</div>';
    box.style.display = '';
  }

  /* ⛔ THE DESIGNER CANNOT RUN IN A FRAME (Ryan 2026-11-04, RW-1536-B). Shopify serves every storefront page with
     X-Frame-Options: DENY and frame-ancestors 'none', so a hidden iframe here never loaded: each run held Send Quote for
     its full 3 minutes and ended "it took too long", and a colour change never reached the layout. The layout can only
     be drawn by the designer in a browser, so the button opens it in a visible tab with the change in the URL
     (custom-room-designer-storage.js _maybeApplyFloorSwap applies it, saves and redraws), and coming back re-checks. */
  function _layoutLines(check) {
    var lines = [];
    if (check.swapFrom.length) lines.push('The layout still shows ' + check.staleNames.join(', ') + ', and this quote has a different colour.');
    if (check.removeEq.length) lines.push('The layout still has equipment that was taken off this quote.');
    if (check.staleDrawing && !check.swapFrom.length && !check.removeEq.length) lines.push('The layout was saved after its PDF pages were drawn, so the PDF would show the older drawing.');
    return lines.concat(check.flags);
  }
  /* Another version of this deal on the same plan, or ''. */
  function _sharedSibling(d) {
    var base = String(state.ref).replace(/-[A-Z]$/, '');
    return (Array.isArray(d.linkedRefs) ? d.linkedRefs : []).filter(function(r) { return r !== state.ref && String(r).replace(/-[A-Z]$/, '') === base; })[0] || '';
  }
  /* This quote takes its own copy of a shared plan, then the change lands on the copy. The tab opens inside the click, before
     the copy answers, or the browser blocks it as a popup. Call it from a click. */
  function _splitAndOpen(sib, check) {
    var tab = check.autoNeeded ? window.open('about:blank', '_blank') : null;
    API.post('/quote-copy-layout', { ref: state.ref, fromRef: sib, replace: true }).then(function(res) {
      if (!res || !res.copied) throw new Error((res && res.error) || 'Copy failed');
      state.linkedFiles = (Array.isArray(state.linkedFiles) ? state.linkedFiles : []).filter(function(f) { return !(f && f.type === 'floor-plan'); })
        .concat([{ type: 'floor-plan', designId: res.designId, designRef: res.designRef }]);
      showToast(state.ref + ' now has its own plan, ' + res.designRef + '.', 'success');
      if (tab) tab.location = _layoutFixUrl({ designId: res.designId }, state.ref, check);
      Q.refreshLayoutSync();
    }).catch(function(err) {
      if (tab) { try { tab.close(); } catch (_e) {} }
      showToast('Could not make a separate plan, so nothing was changed: ' + (err && err.message || err), 'error');
      Q.refreshLayoutSync();
    });
  }
  function _layoutFixUrl(fp, ref, check) {
    return '/pages/rep-gym-designer?designId=' + encodeURIComponent(fp.designId) + '&fixFor=' + encodeURIComponent(ref)
      + (check.swapFrom.length ? '&swapFrom=' + encodeURIComponent(check.swapFrom.join(',')) + '&swapTo=' + encodeURIComponent(check.swapTo.join(',')) : '')
      + (check.removeEq.length ? '&removeEq=' + encodeURIComponent(check.removeEq.join(',')) : '')
      + ((!check.swapFrom.length && !check.removeEq.length && check.staleDrawing) ? '&redraw=1' : '');
  }
  document.addEventListener('rq-ws:saved', function() { if (Q.refreshLayoutSync) Q.refreshLayoutSync(); });
  /* Ryan 2026-10-10: "Update layout" saves in ANOTHER tab, so check again when the rep comes back to this one
     (only while the line is showing; at most every 3 s). */
  var _syncLastFocus = 0;
  function _syncOnReturn() {
    if (document.visibilityState === 'hidden') return;
    var box = wrap.querySelector('.rq-ws-layout-sync');
    if (!box || box.style.display === 'none') return;
    var now = Date.now();
    if (now - _syncLastFocus < 3000) return;
    _syncLastFocus = now;
    if (Q.refreshLayoutSync) Q.refreshLayoutSync();
  }
  window.addEventListener('focus', _syncOnReturn);
  document.addEventListener('visibilitychange', _syncOnReturn);

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-24) — the manual "Repeat buyer" override CHECKBOX was
     removed from Terms & Options; auto-detection is the whole mechanism now. The server
     (lib/repeat-buyer.js isRepeatBuyer, prior SOLD deal on email OR phone) still decides, and still
     ORs in a legacy wm.repeatBuyerOverride, so the 🔁 pill behaves exactly as before — there is just
     no rep-facing control feeding it. state.repeatBuyerOverride is kept because applyRepeatBuyer
     adopts the server's value for the pill; nothing in the UI writes it any more. */
  Q.refreshRepeatPill = function() {
    var show = !!(state._repeatAuto || state.repeatBuyerOverride);
    var pill = document.querySelector('[data-repeat-pill]');
    if (pill) pill.style.display = show ? '' : 'none';
  };
  /* Apply the server's repeatBuyer bundle (from /quote-details) on load. */
  Q.applyRepeatBuyer = function(rb) {
    rb = rb || {};
    state._repeatAuto = !!rb.auto;
    state._repeatCount = rb.count || 0;
    state._repeatFirstSoldAt = rb.firstSoldAt || null;
    if (typeof rb.override === 'boolean') state.repeatBuyerOverride = rb.override;
    Q.refreshRepeatPill();
  };

  var cfaSelect = wrap.querySelector('select[data-field="cfaAttribution"]');
  var cfaHasOptions = false; // tracks whether there are CFA reps available
  if (cfaSelect) {
    cfaSelect.addEventListener('change', function() { state.cfaAttribution = this.value; state.dirty = true; Q.recalcTotals(); });
    // Populate CFA dropdown from cfa-list (accessible to all authenticated reps)
    API.get('/cfa-list').then(function(data) {
      var cfaReps = data.cfas || [];
      if (cfaReps.length > 0) {
        cfaHasOptions = true;
        // Add "None" option after the "-- Select --" placeholder
        var noneOpt = document.createElement('option');
        noneOpt.value = 'none';
        noneOpt.textContent = 'None';
        cfaSelect.appendChild(noneOpt);
        // Add CFA reps
        cfaReps.forEach(function(r) {
          var opt = document.createElement('option');
          opt.value = r.code;
          opt.textContent = r.fullName || r.name || r.code;
          cfaSelect.appendChild(opt);
        });
        // Re-apply saved CFA value now that options exist (includes 'none')
        if (state.cfaAttribution && state.cfaAttribution !== '') {
          cfaSelect.value = state.cfaAttribution;
        }
        // Rebuild custom select widget to show new options
        var cfaCustom = wrap.querySelector('.rq-ws-custom-select[data-field="cfaAttribution"]');
        if (cfaCustom && cfaCustom._drop) {
          cfaCustom._drop.innerHTML = '';
          for (var oi = 0; oi < cfaSelect.options.length; oi++) {
            var optBtn = document.createElement('button');
            optBtn.type = 'button';
            optBtn.className = 'rq-ws-custom-select__opt';
            optBtn.setAttribute('data-value', cfaSelect.options[oi].value);
            optBtn.textContent = cfaSelect.options[oi].textContent;
            cfaCustom._drop.appendChild(optBtn);
          }
        }
        syncCustomSelect(cfaSelect);
        // Show the red asterisk
        var cfaLabel = cfaSelect.closest('.rq-ws-field');
        if (cfaLabel) {
          var asterisk = cfaLabel.querySelector('.rq-ws-field__label span');
          if (asterisk) asterisk.style.display = '';
        }
      } else {
        // No CFAs — gray out the custom select widget and hide asterisk
        cfaSelect.disabled = true;
        var cfaCustom = wrap.querySelector('.rq-ws-custom-select[data-field="cfaAttribution"]');
        if (cfaCustom) {
          cfaCustom.style.opacity = '0.5';
          cfaCustom.style.pointerEvents = 'none';
          if (cfaCustom._btn) cfaCustom._btn.textContent = '—';
        }
        var cfaLabel = cfaSelect.closest('.rq-ws-field');
        if (cfaLabel) {
          var asterisk = cfaLabel.querySelector('.rq-ws-field__label span');
          if (asterisk) asterisk.style.display = 'none';
        }
      }
    }).catch(function() {});
  }
  wrap.querySelector('select[data-field="terms"]').addEventListener('change', function() { state.send.terms = this.value; Q.recalcTotals(); });
  // Lead Time select + Other
  var leadTimeSel = wrap.querySelector('select[data-field="leadTime"]');
  var leadTimeCustom = wrap.querySelector('.rq-ws-leadtime-custom');
  leadTimeSel.addEventListener('change', function() {
    if (this.value === '__other') {
      leadTimeCustom.style.display = '';
      leadTimeCustom.focus();
      state.send.leadTime = leadTimeCustom.value;
    } else {
      leadTimeCustom.style.display = 'none';
      state.send.leadTime = this.value;
    }
  });
  leadTimeCustom.addEventListener('input', function() {
    state.send.leadTime = this.value;
  });
  wrap.querySelector('[data-field="expiration"]').addEventListener('change', function() { state.send.expiration = this.value; });

  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Sales Rep override inputs (admin-only).
     Block is hidden by default in the section markup; revealed below for
     admin users. Each field writes back to state.salesRepOverride and
     marks the quote dirty so the save flow picks it up.

     Memory: a localStorage-backed dictionary keyed by lowercase name lets
     admin retype a saved person's name and auto-fill phone + email. The
     datalist surfaces saved names as native browser suggestions. Memory
     upserts after each /save-workstation that emits a non-null override
     (see Q.salesRepMemoryUpsert below).

     Phone formatting: blur normalizes US 10-digit input ("7777777777" or
     "1-777-777-7777") to "(777) 777-7777". Non-US / partial digits pass
     through unchanged so admin can type whatever shape the actual rep has. */
  var REP_MEMORY_KEY = 'bsfs_sales_rep_override_memory';
  function loadRepMemory() {
    try {
      var raw = localStorage.getItem(REP_MEMORY_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function saveRepMemory(arr) {
    try { localStorage.setItem(REP_MEMORY_KEY, JSON.stringify(arr.slice(0, 50))); } catch (e) {}
  }
  function repMemoryUpsert(entry) {
    if (!entry || !entry.name) return;
    var arr = loadRepMemory();
    var key = entry.name.trim().toLowerCase();
    if (!key) return;
    var idx = arr.findIndex(function (e) { return (e.name || '').trim().toLowerCase() === key; });
    var merged = {
      name: entry.name.trim(),
      phone: (entry.phone || '').trim(),
      email: (entry.email || '').trim(),
      lastUsedAt: new Date().toISOString(),
    };
    if (idx >= 0) {
      // Preserve fields that the new entry left blank.
      merged.phone = merged.phone || arr[idx].phone || '';
      merged.email = merged.email || arr[idx].email || '';
      arr.splice(idx, 1);
    }
    arr.unshift(merged); // most-recent first
    saveRepMemory(arr);
    paintDatalist();
  }
  Q.salesRepMemoryUpsert = repMemoryUpsert;
  function paintDatalist() {
    var dl = wrap.querySelector('#rq-ws-rep-override-names');
    if (!dl) return;
    var arr = loadRepMemory();
    dl.innerHTML = arr.map(function (e) {
      return '<option value="' + (e.name || '').replace(/"/g, '&quot;') + '">';
    }).join('');
  }
  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Progressive US phone formatter. Formats
     as the admin types so the field always reads cleanly:
       "7"           → "(7"
       "777"         → "(777"
       "7777"        → "(777) 7"
       "7777777"     → "(777) 777-7"
       "7777777777"  → "(777) 777-7777"
       "1-777-777-7777" → "(777) 777-7777"  (strips leading 1)
     International / non-US shapes pass through unchanged:
       contains "+"     → raw text
       11+ digits not starting with 1 → raw text */
  function formatPhoneNumber(raw) {
    var s = String(raw || '');
    if (!s) return '';
    if (s.indexOf('+') !== -1) return s;
    var digits = s.replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    if (digits.length > 10) return s; // not a US shape — don't mangle
    if (digits.length === 0) return '';
    if (digits.length <= 3) return '(' + digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
  var repOverrideBlock = wrap.querySelector('.rq-ws-rep-override');
  if (repOverrideBlock && Q.isAdmin) {
    repOverrideBlock.style.display = '';
    paintDatalist();
    var roName = wrap.querySelector('[data-field="salesRepOverrideName"]');
    var roPhone = wrap.querySelector('[data-field="salesRepOverridePhone"]');
    var roEmail = wrap.querySelector('[data-field="salesRepOverrideEmail"]');
    function _ensureOverrideObj() {
      if (!state.salesRepOverride) state.salesRepOverride = { name: '', phone: '', email: '' };
    }
    if (roName) {
      roName.addEventListener('input', function () {
        _ensureOverrideObj();
        state.salesRepOverride.name = this.value;
        state.dirty = true;
        // Exact-match (case-insensitive) → auto-fill phone + email if those
        // are blank. Don't clobber admin's in-progress edits in the other
        // two fields if they typed something already.
        var key = this.value.trim().toLowerCase();
        if (!key) return;
        var hit = loadRepMemory().find(function (e) { return (e.name || '').trim().toLowerCase() === key; });
        if (!hit) return;
        if (roPhone && !state.salesRepOverride.phone && hit.phone) {
          roPhone.value = hit.phone;
          state.salesRepOverride.phone = hit.phone;
        }
        if (roEmail && !state.salesRepOverride.email && hit.email) {
          roEmail.value = hit.email;
          state.salesRepOverride.email = hit.email;
        }
      });
    }
    if (roPhone) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Real-time progressive formatting.
         Format on every input, write the formatted value back, and park
         the cursor at the end (typing-forward is the dominant case;
         keeping the cursor in the right place for mid-string edits would
         need a much more complex implementation that's rarely worth it
         for a phone field). state.dirty + state.salesRepOverride mirror
         the formatted value so the save payload + memory upsert see the
         pretty version, not the raw digits. */
      roPhone.addEventListener('input', function () {
        var formatted = formatPhoneNumber(this.value);
        if (formatted !== this.value) {
          this.value = formatted;
          // Park cursor at end so typing-forward feels natural.
          try { this.setSelectionRange(formatted.length, formatted.length); } catch (e) {}
        }
        _ensureOverrideObj();
        state.salesRepOverride.phone = formatted;
        state.dirty = true;
      });
      // Blur kept as a safety net (paste-and-tab without input firing on
      // some old browsers; also catches the rare case where the field
      // value got mutated externally).
      roPhone.addEventListener('blur', function () {
        var formatted = formatPhoneNumber(this.value);
        if (formatted !== this.value) {
          this.value = formatted;
          _ensureOverrideObj();
          state.salesRepOverride.phone = formatted;
          state.dirty = true;
        }
      });
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }
    if (roEmail) roEmail.addEventListener('input', function () { _ensureOverrideObj(); state.salesRepOverride.email = this.value; state.dirty = true; });
  }
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Existing Credit (admin-only). Captures
     an amount the customer has already paid (e.g. deposit on an earlier
     quote in a linked order chain). Renders as a negative line in totals
     + reduces the payment link total. Hidden for non-admin reps. */
  var existingCreditBlock = wrap.querySelector('.rq-ws-existing-credit');
  if (existingCreditBlock && Q.isAdmin) {
    existingCreditBlock.style.display = '';
    var ecAmount = wrap.querySelector('[data-field="existingCreditAmount"]');
    var ecSourceRef = wrap.querySelector('[data-field="existingCreditSourceRef"]');
    function _ensureCreditObj() {
      if (!state.existingCredit) state.existingCredit = { amount: 0, sourceRef: '' };
    }
    if (ecAmount) {
      ecAmount.addEventListener('input', function () {
        _ensureCreditObj();
        state.existingCredit.amount = Q.parseMoney(this.value);
        Q.liveFmtMoney(this);
        Q.recalcTotals();
      });
      ecAmount.addEventListener('blur', function () {
        if (this.value && this.value.trim()) this.value = Q.fmt(Q.parseMoney(this.value));
      });
    }
    if (ecSourceRef) {
      ecSourceRef.addEventListener('input', function () {
        _ensureCreditObj();
        state.existingCredit.sourceRef = this.value.trim().toUpperCase();
        if (this.value !== state.existingCredit.sourceRef) this.value = state.existingCredit.sourceRef;
        state.dirty = true;
        Q.recalcTotals();
      });
    }
  }
  /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

  /* ── Save Mode Logic ── */
  function updateSaveButton() {
    // CUSTOM_RFQPORTAL_BY_CLAUDE — keep the Send button gate in sync on
    // every Save-button refresh (load, save, save-as). Runs first so the
    // early-return below for new/unsaved quotes still updates Send.
    updateSendButton();
    var saveBtn = wrap.querySelector('.rq-ws-send__save');
    var saveAsBtn = wrap.querySelector('.rq-ws-send__save-as');
    if (!saveBtn || !saveAsBtn) return;

    var hasRef = !!state.ref;
    var totalChanged = state.loadedGrandTotal !== null && state.lastGrandTotal !== state.loadedGrandTotal;
    var mustSaveAs = hasRef && totalChanged && state.pdfDownloaded && !isAdmin;

    if (!hasRef) {
      saveBtn.classList.remove('rq-ws-sidebar-actions__btn--disabled');
      saveBtn.disabled = false;
      saveAsBtn.style.display = 'none';
      return;
    }

    saveAsBtn.style.display = '';
    if (mustSaveAs) {
      saveBtn.classList.add('rq-ws-sidebar-actions__btn--disabled');
      saveBtn.disabled = true;
    } else {
      saveBtn.classList.remove('rq-ws-sidebar-actions__btn--disabled');
      saveBtn.disabled = false;
    }
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-30) — Send Quote enable state.
     The section ships .rq-ws-send__send `disabled` + inline opacity:0.45 so
     it never flashes clickable before JS boots. The OLD /send-quote flow
     left it permanently grayed because nothing re-enabled it under the new
     Outlook-composer flow. This mirrors the Download-PDF gate: the button
     is clickable once there's a loaded/valid quote with a customer email
     (same precondition Download-PDF + the composer need — a saved ref the
     PDF can be generated from, plus a recipient). For a genuinely empty /
     invalid quote it stays grayed.

     "Valid quote" here = has a ref (saved) AND ≥1 line item AND a customer
     email present. We strip the inline opacity/cursor styles the section
     hardcoded and let the .rq-ws-sidebar-actions__btn--disabled class own
     the grayed look when it's not yet sendable. */
  function updateSendButton() {
    var sendBtn = wrap.querySelector('.rq-ws-send__send');
    if (!sendBtn) return;

    var emailEl = wrap.querySelector('[data-field="email"]');
    var hasEmail = !!(emailEl && emailEl.value && emailEl.value.trim());
    var hasItems = Array.isArray(state.items) && state.items.length > 0;
    var canSend = !!state.ref && hasItems && hasEmail;

    // Clear the section's hardcoded inline disabled styling so the live
    // class-driven state can take over (the inline opacity/cursor would
    // otherwise keep it looking grayed even after we enable it).
    sendBtn.style.opacity = '';
    sendBtn.style.cursor = '';

    if (canSend) {
      sendBtn.disabled = false;
      sendBtn.classList.remove('rq-ws-sidebar-actions__btn--disabled');
    } else {
      sendBtn.disabled = true;
      sendBtn.classList.add('rq-ws-sidebar-actions__btn--disabled');
    }
  }

  /* ── Save Draft ── */
  wrap.querySelector('.rq-ws-send__save').addEventListener('click', function() {
    var btn = this;
    /* CUSTOM_ROOMDESIGNER_BY_CLAUDE — Pending revision (RD Mode 2 floor-plan handoff):
       reroute Save → Save As so the new revision (-B) is minted via /clone-quote instead
       of overwriting the source revision (-A) we loaded for context. Flag is set in
       workstation-boot.js after loadQuote(source) + items are imported. Cleared in
       saveAsDraft on success. */
    if (state.pendingRevisionBase) {
      saveAsDraft(btn);
      return;
    }
    if (Q.maybePromptECleaner && Q.maybePromptECleaner('save', function() { saveDraft(btn); })) return;
    saveDraft(btn);
  });

  /* CUSTOM_QUOTELAYOUTCOPY_BY_CLAUDE (Ryan 2026-10-10) — Save As on a quote with a gym layout asks, in plain
     English, whether the new version gets its own copy of it (Yes is the default and takes Enter). Replaced
     the "Keep on Save As" box in Terms & Options: the choice is about this one action, so it is asked at it.
     No layout on the quote, or a designer hand-off (pendingLinkDesign, which links the design itself):
     no question, Save As as before. Backdrop / Escape cancels the Save As. Dark portal, the Workstation's
     own dialog look (the E-Cleaner prompt's). */
  var _layoutAskStyled = false;
  function styleAskDialog() {
    if (!_layoutAskStyled) {
      _layoutAskStyled = true;
      var st = document.createElement('style');
      st.textContent =
        '.rq-ws-layout-ask{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center}' +
        '.rq-ws-layout-ask__backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.4)}' +
        '.rq-ws-layout-ask__dialog{position:relative;width:540px;max-width:92vw;background:var(--rq-bg-surface);border:2px solid var(--rq-border);border-radius:12px;box-shadow:0 12px 36px rgba(0,0,0,0.22)}' +
        '.rq-ws-layout-ask__header{padding:14px 18px;border-bottom:1px solid var(--rq-border)}' +
        '.rq-ws-layout-ask__title{font-family:Montserrat,sans-serif;font-size:15px;font-weight:700;color:var(--rq-text);margin:0}' +
        '.rq-ws-layout-ask__body{padding:18px}' +
        '.rq-ws-layout-ask__msg{font-family:Montserrat,sans-serif;font-size:14px;color:var(--rq-text);margin:0;line-height:1.5}' +
        '.rq-ws-layout-ask__footer{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:10px;padding:14px 18px;border-top:1px solid var(--rq-border)}' +
        /* Ryan 2026-10-30: three buttons wrapped their words ("Clo / se"). A label never breaks; a narrow screen moves a whole button to the next row. */
        '.rq-ws-layout-ask__footer .rep-quote-btn{white-space:nowrap;flex:0 0 auto;width:auto;font-size:13px;padding-left:14px;padding-right:14px}';
      document.head.appendChild(st);
    }
  }
  function askKeepLayout(onAnswer) {
    styleAskDialog();
    var m = document.createElement('div');
    m.className = 'rq-ws-layout-ask';
    m.innerHTML =
      '<div class="rq-ws-layout-ask__backdrop"></div>' +
      '<div class="rq-ws-layout-ask__dialog" role="dialog" aria-modal="true">' +
        '<div class="rq-ws-layout-ask__header"><h3 class="rq-ws-layout-ask__title">Copy the gym layout to the new version?</h3></div>' +
        '<div class="rq-ws-layout-ask__body"><p class="rq-ws-layout-ask__msg">The new version will get its own copy of this quote\'s gym layout, so its PDF has a layout page. ' +
          'If you change its flooring colour, you can then update its layout to match.</p></div>' +
        '<div class="rq-ws-layout-ask__footer">' +
          '<button class="rep-quote-btn rep-quote-btn--secondary rq-ws-layout-ask__no" type="button">No layout</button>' +
          '<button class="rep-quote-btn rep-quote-btn--primary rq-ws-layout-ask__yes" type="button">Yes, copy it</button>' +
        '</div>' +
      '</div>';
    wrap.appendChild(m);
    var done = false;
    function close(answer) {
      if (done) return;
      done = true;
      document.removeEventListener('keydown', onKey, true);
      m.remove();
      if (answer !== null) onAnswer(answer);
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(null); }
      else if (e.key === 'Enter') { e.preventDefault(); close(document.activeElement === m.querySelector('.rq-ws-layout-ask__no') ? false : true); }
    }
    m.querySelector('.rq-ws-layout-ask__yes').addEventListener('click', function() { close(true); });
    m.querySelector('.rq-ws-layout-ask__no').addEventListener('click', function() { close(false); });
    m.querySelector('.rq-ws-layout-ask__backdrop').addEventListener('click', function() { close(null); });
    document.addEventListener('keydown', onKey, true);
    setTimeout(function() { var y = m.querySelector('.rq-ws-layout-ask__yes'); if (y) y.focus(); }, 0);
  }

  /* CUSTOM_SENDFREIGHTCHECK_BY_CLAUDE (Ryan 2026-10-25, RW-1490-A/-B: "should Send Quote grey out?" - his pick: warn, and
     STOP only when the price was copied) - Send Quote on a quote whose items changed since freight was quoted asks first, in
     the Workstation's own dialog look. Two buttons: Re-request freight (the Fees & Extras drop-down) or Send anyway. When the
     freight price was applied before this version existed (a Save As copied it), it was never quoted for these items at all:
     no Send anyway, and the box says how to send without freight. Not greyed out: a grey button cannot say why. */
  var _freightSendOk = null; // the change signature the rep said Send anyway to
  function askFreightBeforeSend(ch, onSendAnyway) {
    styleAskDialog();
    var f = state.freight || {};
    var fee = state.fees && state.fees[0];
    var price = fee && fee.status === 'free' ? 'FREE' : '$' + Number((fee && fee.amount) || f.totalQuoted || 0).toFixed(2);
    var esc = Q.escHtml || function(x) { return String(x); };
    var msg = ch.copied
      ? 'The freight on this quote (' + price + ') was copied from another version and was never quoted for these items: ' + esc(ch.parts.join('; ')) + '. Re-request freight first, or set Shipping & Freight to Pending to send the quote without a freight price.'
      : 'The freight on this quote (' + price + ') was quoted for different items: ' + esc(ch.parts.join('; ')) + '. Sending now gives the customer a freight price that may be wrong.';
    var m = document.createElement('div');
    m.className = 'rq-ws-layout-ask';
    m.innerHTML =
      '<div class="rq-ws-layout-ask__backdrop"></div>' +
      '<div class="rq-ws-layout-ask__dialog" role="dialog" aria-modal="true">' +
        '<div class="rq-ws-layout-ask__header"><h3 class="rq-ws-layout-ask__title">' + (ch.copied ? 'Freight needs a new quote before sending' : 'Items changed since freight was quoted') + '</h3></div>' +
        '<div class="rq-ws-layout-ask__body"><p class="rq-ws-layout-ask__msg">' + msg + '</p></div>' +
        '<div class="rq-ws-layout-ask__footer">' +
          (ch.copied
            ? '<button class="rep-quote-btn rep-quote-btn--secondary rq-ws-layout-ask__no" type="button">Close</button>'
            : '<button class="rep-quote-btn rep-quote-btn--secondary rq-ws-layout-ask__no" type="button">Send anyway</button>') +
          /* CUSTOM_FREIGHTFITS_BY_CLAUDE (Ryan 2026-10-30, RW-1514-B) - admins: the freight still covers these items, so it
             stays, the warnings stop for this list of items, and the send goes on (its save writes the deal-feed line) */
          (isAdmin && Q.confirmFreightFits ? '<button class="rep-quote-btn rep-quote-btn--secondary rq-ws-layout-ask__fits" type="button" title="The freight already on this quote covers the items now on it. Keeps the price and sends.">Freight still fits</button>' : '') +
          '<button class="rep-quote-btn rep-quote-btn--primary rq-ws-layout-ask__yes" type="button">Re-request freight</button>' +
        '</div>' +
      '</div>';
    wrap.appendChild(m);
    var done = false;
    function close(answer) {
      if (done) return;
      done = true;
      document.removeEventListener('keydown', onKey, true);
      m.remove();
      if (answer === 'rerequest' && Q.openRequestDropdown) setTimeout(Q.openRequestDropdown, 0);
      if (answer === 'send') onSendAnyway();
      if (answer === 'fits' && Q.confirmFreightFits(ch)) onSendAnyway(); // CUSTOM_FREIGHTFITS_BY_CLAUDE
    }
    var fitsBtn = m.querySelector('.rq-ws-layout-ask__fits');
    if (fitsBtn) fitsBtn.addEventListener('click', function() { close('fits'); });
    function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); close(null); } }
    m.querySelector('.rq-ws-layout-ask__yes').addEventListener('click', function() { close('rerequest'); });
    m.querySelector('.rq-ws-layout-ask__no').addEventListener('click', function() { close(ch.copied ? null : 'send'); });
    m.querySelector('.rq-ws-layout-ask__backdrop').addEventListener('click', function() { close(null); });
    document.addEventListener('keydown', onKey, true);
    setTimeout(function() { var y = m.querySelector('.rq-ws-layout-ask__yes'); if (y) y.focus(); }, 0);
  }

  /* CUSTOM_QUOTELAYOUTSWAP_BY_CLAUDE (Ryan 2026-11-04, RW-1536-C: "when I click download PDF or Send quote isn't a pop-up
     supposed to appear") - Send Quote and Download PDF re-check the layout first, when this quote's PDF carries one. The line
     under Gym Layout is easy to miss, and RW-1536-C's PDF showed another version's drawing with it on screen. Two buttons, the
     freight pop-up's shape: Update layout, or Continue anyway. Never blocks: no layout page, a slow answer or a failed read goes
     straight on. A Continue anyway holds until the layout or the quote changes. */
  var _layoutPdfOk = null;  // the signature the rep said Continue anyway to
  var _layoutGateBusy = false;
  function _layoutProblem(fp, d, items) {
    if (!d || !d.planItems) return null;
    var check = _layoutCheck(d, items || []);
    if (!check.autoNeeded && !check.flags.length) return null;
    return {
      check: check, lines: _layoutLines(check), sib: _sharedSibling(d),
      sig: [fp.designId, d.designUpdatedAt || '', check.swapFrom.join(','), check.swapTo.join(','), check.removeEq.join(','), check.flags.join('|')].join('~'),
    };
  }
  function askLayoutBeforePdf(fp, p, onContinue) {
    styleAskDialog();
    var esc = Q.escHtml || function(x) { return String(x); };
    var auto = p.check.autoNeeded;
    var m = document.createElement('div');
    m.className = 'rq-ws-layout-ask';
    m.innerHTML =
      '<div class="rq-ws-layout-ask__backdrop"></div>' +
      '<div class="rq-ws-layout-ask__dialog" role="dialog" aria-modal="true">' +
        '<div class="rq-ws-layout-ask__header"><h3 class="rq-ws-layout-ask__title">The gym layout in this PDF is out of date</h3></div>' +
        '<div class="rq-ws-layout-ask__body"><p class="rq-ws-layout-ask__msg">' + esc(p.lines.join(' ')) + '</p></div>' +
        '<div class="rq-ws-layout-ask__footer">' +
          '<button class="rep-quote-btn rep-quote-btn--secondary rq-ws-layout-ask__no" type="button">Continue anyway</button>' +
          '<button class="rep-quote-btn rep-quote-btn--primary rq-ws-layout-ask__yes" type="button">' + (auto ? 'Update layout' : 'Fix in layout') + '</button>' +
        '</div>' +
      '</div>';
    wrap.appendChild(m);
    var done = false;
    function close() {
      if (done) return false;
      done = true;
      document.removeEventListener('keydown', onKey, true);
      m.remove();
      return true;
    }
    function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); close(); } }
    m.querySelector('.rq-ws-layout-ask__yes').addEventListener('click', function() {
      if (!close()) return;
      if (p.sib && auto) _splitAndOpen(p.sib, p.check);
      else window.open(_layoutFixUrl(fp, state.ref, p.check), '_blank');
      showToast(auto ? 'When the green banner shows in the new tab, come back and click again.' : 'Fix it in the layout, click Save + proposal previews there, then come back and click again.', 'info');
    });
    m.querySelector('.rq-ws-layout-ask__no').addEventListener('click', function() { if (close()) { _layoutPdfOk = p.sig; onContinue(); } });
    m.querySelector('.rq-ws-layout-ask__backdrop').addEventListener('click', function() { close(); });
    document.addEventListener('keydown', onKey, true);
    setTimeout(function() { var y = m.querySelector('.rq-ws-layout-ask__yes'); if (y) y.focus(); }, 0);
  }
  function checkLayoutBeforePdf(onGo) {
    var fp = _floorPlanOf(state.linkedFiles);
    if (!state.ref || state.pendingLinkDesign || !state.includeLayoutInPdf || !fp) { onGo(); return; }
    if (_layoutGateBusy) return;   // a second click while the first is still reading
    _layoutGateBusy = true;
    var settled = false;
    function settle(d) {
      if (settled) return;
      settled = true;
      _layoutGateBusy = false;
      var p = null;
      try { p = _layoutProblem(fp, d, state.items); } catch (_e) { p = null; }
      if (!p || _layoutPdfOk === p.sig) { onGo(); return; }
      askLayoutBeforePdf(fp, p, onGo);
    }
    setTimeout(function() { settle(null); }, 4000);
    API.get('/design-items/' + encodeURIComponent(fp.designId)).then(settle, function() { settle(null); });
  }

  wrap.querySelector('.rq-ws-send__save-as').addEventListener('click', function() {
    var btn = this;
    if (state.ref && _floorPlanOf(state.linkedFiles) && !state.pendingLinkDesign && !state.pendingRevisionBase) {
      askKeepLayout(function(keep) { saveAsDraft(btn, keep); });
      return;
    }
    saveAsDraft(btn, false);
  });

  function validateRequired() {
    var customer = Q.getCustomerData();
    var errors = [];
    // Clear previous highlights
    var mc = 'rq-ws-field__input--missing';
    wrap.querySelectorAll('.' + mc).forEach(function(el) { el.classList.remove(mc); });

    function flagField(sel) {
      var el = wrap.querySelector(sel);
      if (!el) return;
      // Custom select widget — add to container div (CSS cascades to button)
      var df = el.getAttribute('data-field');
      if (df) {
        var csWrap = wrap.querySelector('.rq-ws-custom-select[data-field="' + df + '"]');
        if (csWrap) { csWrap.classList.add(mc); return; }
      }
      el.classList.add(mc);
    }

    if (!customer.name) { errors.push('Customer name is required'); flagField('[data-field="name"]'); }
    // Pending drafts (no items) only need a name
    if (state.items.length === 0) return errors;
    // Full quotes need everything
    if (!customer.email) { errors.push('Customer email is required'); flagField('[data-field="email"]'); }
    // Sync lead source + CFA from DOM in case change event didn't fire
    var lsEl = wrap.querySelector('select[data-field="leadSource"]');
    if (lsEl) state.leadSource = lsEl.value || '';
    var cfaEl = wrap.querySelector('select[data-field="cfaAttribution"]');
    if (cfaEl && cfaEl.value) state.cfaAttribution = cfaEl.value;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — ⛔ A REPLACEMENT IS NOT A DEAL, SO IT
       IS NOT ASKED THE TWO DEAL QUESTIONS. Both of these were blocking the save on the very
       first real replacement (RPL-1001-A): "Deal Type is required" and "CFA attribution is
       required", on a $0 re-ship where neither field has a true answer.
         · Deal Type (leadSource) is the COMMISSION field — inbound vs outbound picks the
           rep's rate and shared pays a partner a cut of GP. A replacement pays nobody, and
           handleSaveWorkstation deliberately does not even write a `leadSource:` tag on one.
         · CFA Attribution is forced to 'none' in replacement mode for the same reason, and
           re-forced server-side, so there is nothing left for the rep to answer.
       Everything else on this gate still applies — name, email, and the MAP check below. */
    if (!state.isReplacement && !state.leadSource) { errors.push('Deal Type is required (Terms & Options)'); flagField('[data-field="leadSource"]'); }
    /* CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI decoupling piece 3) — the
       "Lead Source is required when Deal Type = Inbound" rule is GONE with the
       dropdown. Nothing a rep types classifies marketing origin any more, so
       there is no longer a field to require. */
    if (!state.isReplacement && cfaHasOptions && !state.cfaAttribution) { errors.push('CFA attribution is required (Terms & Options)'); flagField('[data-field="cfaAttribution"]'); }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Referral guard. On a Shared Deal with a
       Referred By name set, the % of GP MUST be > 0 before save — otherwise
       we'd ship a paying referral the commission engine can't compute against.
       Only fires on Shared Deal (tracking referrals on other Deal Types carry
       GP% 0 by design). The name itself isn't required; the % is, once a name
       is present. */
    if (state.leadSource === 'shared' && state.referral && state.referral.name && (!state.referral.gpPercent || state.referral.gpPercent <= 0)) {
      errors.push('% of GP is required when a Shared With name is set on a Shared Deal (Terms & Options)');
      flagField('[data-field="referralGpPercent"]');
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — ⛔ A CARTON PRODUCT CANNOT BE SAVED OFF
       THE CARTON. The qty snap in workstation-table.js rounds a typed 23 up on blur; this is the
       lock for the value that never blurred (a GLD handoff edited in place, a series propagate,
       a pasted number). Same arithmetic, one source: Q.cartonStepFor. */
    if (Q.cartonStepFor) {
      var offCarton = state.items.filter(function(i) {
        var step = Q.cartonStepFor(i);
        return step > 1 && ((parseInt(i.quantity, 10) || 0) % step) !== 0;
      });
      if (offCarton.length) {
        offCarton.forEach(function(i) {
          var step = Q.cartonStepFor(i);
          var unitWord = i.unitMode === 'sqft' ? 'sq ft' : 'planks';
          errors.push((i.sku || i.title) + ' sells by the carton only (' + step + ' ' + unitWord + ' per carton) — qty ' + i.quantity + ' is not whole cartons');
          var qtyEl = wrap.querySelector('tr[data-item-id="' + i.id + '"] [data-field="quantity"]');
          if (qtyEl) qtyEl.classList.add('rq-ws-table__input--missing');
        });
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    // Freight/install unset-type validation removed
    // Block if any product's Direct price exceeds MAP
    var overMapItems = state.items.filter(function(i) { return !i.isFree && i.directPrice > 0 && i.mapPrice > 0 && i.directPrice > i.mapPrice; });
    if (overMapItems.length) {
      var names = overMapItems.map(function(i) { return i.sku || i.title; }).join(', ');
      errors.push('Direct price exceeds MAP on: ' + names + ' — lower points or adjust pricing');
    }
    return errors;
  }

  // Clear red highlight on input/change
  var mc = 'rq-ws-field__input--missing';
  wrap.addEventListener('input', function(e) {
    if (e.target.classList.contains(mc)) e.target.classList.remove(mc);
    // CUSTOM_RFQPORTAL_BY_CLAUDE — live Send-button gate (e.g. typing the
    // customer email should flip Send clickable without a re-save).
    updateSendButton();
  });
  wrap.addEventListener('change', function(e) {
    if (e.target.classList.contains(mc)) e.target.classList.remove(mc);
    updateSendButton();
    // Custom select: clear from container div when hidden select changes
    var df = e.target.getAttribute('data-field');
    if (df) {
      var csWrap = wrap.querySelector('.rq-ws-custom-select[data-field="' + df + '"]');
      if (csWrap) csWrap.classList.remove(mc);
    }
  });

  function buildSavePayload() {
    var _p = buildSavePayloadInner();
    /* CUSTOM_QUOTELAYOUTCOPY_BY_CLAUDE (Ryan 2026-10-15, RW-1460-C) — the floor plans this quote holds, so a
       save that read a stale record cannot drop them (worker mergeEnsuredFloorPlans; it re-adds only a design
       that still lists this quote). */
    var _fps = (Array.isArray(state.linkedFiles) ? state.linkedFiles : []).filter(function(f) { return f && f.type === 'floor-plan' && f.designId; });
    if (_fps.length) _p.ensureLinkedFiles = _fps.map(function(f) { return { type: 'floor-plan', designId: f.designId, designRef: f.designRef || '' }; });
    return _p;
  }
  function buildSavePayloadInner() {
    var customer = Q.getCustomerData();

    // Compute financials for Dashboard (round each line to cents to avoid IEEE 754 drift)
    var msrpTotal = 0, directTotal = 0, costTotal = 0;
    state.items.forEach(function(item) {
      var qty = item.quantity || 0;
      // msrp === -1 is the "N/A" sentinel — don't roll into msrpTotal.
      var msrpForList = (item.msrp === -1) ? 0 : (item.msrp || item.mapPrice || 0);
      msrpTotal += Math.round(msrpForList * qty * 100) / 100;
      if (!item.isFree) directTotal += Math.round((item.directPrice || 0) * qty * 100) / 100;
      costTotal += Math.round((item.cost || 0) * qty * 100) / 100;
    });
    var shippingAmt = state.fees[0] && state.fees[0].status === 'value' ? (state.fees[0].amount || 0) : 0;
    var installAmt = state.fees[1] && state.fees[1].status === 'value' ? (state.fees[1].amount || 0) : 0;
    var freightCost = state.freight.totalCost || 0;
    var installCost = state.installation.totalCost || 0;
    var freightCharged = shippingAmt;
    var installCharged = installAmt;
    var cardFeeAmt = state.cardFee.status === 'yes' ? (state.cardFee.amount || 0) : 0;
    var taxAmt = state.tax.amount || 0;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-17) — the fourth copy of a formula that
       subtracted two passthroughs it had never added.
         cardFee — the customer pays this 2.9% surcharge ON TOP of the quote; directTotal
                   is goods revenue and has never contained it. Subtracting it charged
                   Blue Sky for money the customer handed over. It is revenue; Shopify's
                   processing cut is the matching expense, and the two roughly cancel.
         tax     — collected and remitted, and likewise absent from directTotal. A wash.
       The worker canonicalises whatever this posts (lib/wm-financials-normalize.js), but
       the rep reads these numbers on screen before the save round-trips, so the client
       has to agree rather than be corrected afterwards.
       Shopify's cut isn't known until the invoice is actually paid — the orders/paid
       webhook reconciles it — so it is absent here and the quote-time GP reads very
       slightly high on a card-paid deal. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — THE CUSTOM FEES WERE NOT IN HERE AT ALL.

       Ryan: *"I added a -$100 discount to RW-1298-A in the QW and I didn't see the financials in
       the QW change at all."* This function builds the `financials` snapshot the Deal Dashboard
       renders and that lib/gp-entitlements.js pays rep commission, CFA commission and referrals
       from — and it computed every figure from `state.items` alone. `state.customFees` was never
       read, so a discount could not reach the number even in principle.

       ⚠️ ONLY THE NEGATIVE HALF. A charge a rep adds is assumed to recover a cost (the old
       pass-through treatment, unchanged); a discount cannot be recovering anything. Split per ROW,
       never on the net — +200 crating with −100 goodwill is two facts, not one +100.
       See the worker's lib/fee-discounts.js for the measurement behind that split.

       ⛔ DERIVED FROM COMPONENTS, NEVER ADJUSTED. `feeDiscounts` also ships as its own field so the
       worker's computeCanonicalGp rebuilds the identical number from (directTotal, costTotal,
       feeDiscounts) instead of subtracting it a second time off what this wrote. */
    var feeDiscounts = 0, feeCharges = 0;
    (state.customFees || []).forEach(function (f) {
      var a = (f && parseFloat(f.amount)) || 0;
      if (a < 0) feeDiscounts += a; else feeCharges += a;
    });
    feeDiscounts = Math.round(feeDiscounts * 100) / 100;
    feeCharges = Math.round(feeCharges * 100) / 100;
    /* Revenue actually collected on goods. Every figure below divides by this rather than
       directTotal: a discounted deal took in less, and dividing the reduced profit by the
       undiscounted revenue would understate the margin twice over. */
    var goodsRevenue = directTotal + feeDiscounts;

    var totalCosts = costTotal + freightCost + installCost;
    var addOnProfit = (freightCharged - freightCost) + (installCharged - installCost);
    var grossProfit = goodsRevenue + cardFeeAmt - costTotal + addOnProfit;
    var grossMargin = goodsRevenue > 0 ? (grossProfit / goodsRevenue * 100) : 0;
    var netProfit = grossProfit - addOnProfit;
    var netMargin = goodsRevenue > 0 ? (netProfit / goodsRevenue * 100) : 0;
    var gpOfGoods = goodsRevenue - costTotal;
    var gpOfGoodsMargin = goodsRevenue > 0 ? (gpOfGoods / goodsRevenue * 100) : 0;
    var vendorMap = {};
    state.items.forEach(function(item) { if (item.vendor) vendorMap[item.vendor] = true; });

    return {
      ref: state.ref,
      draftOrderId: state.draftOrderId || null,
      customer: customer,
      items: state.items.map(function(i) {
        var obj = {
          id: i.id,
          type: i.type,
          variantId: i.variantId,
          vendor: i.vendor,
          title: i.title,
          sku: i.sku,
          quantity: i.quantity,
          msrp: i.msrp,
          cost: i.cost,
          points: i.points,
          directPrice: i.directPrice,
          mapPrice: i.mapPrice || 0,
          isFree: i.isFree,
          subDescriptions: i.subDescriptions || [],
          internalNote: i.internalNote || '',
          seriesId: i.seriesId || null,
          seriesWeight: i.seriesWeight != null ? i.seriesWeight : null,
          seriesBaseTitle: i.seriesBaseTitle || null,
          seriesBaseSku: i.seriesBaseSku || null,
          // CUSTOM_WEIGHTDESIGNER_BY_CLAUDE (Ryan 2026-09-01) — or the exemption dies on save and
          // the reloaded quote propagates across a plate ladder. See workstation-items.js.
          seriesIsPlates: !!i.seriesIsPlates,
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Indent flag. Admin drag-rights on
             the row handle to mark this row as a child of the preceding
             item. Renders indented on the printed PDF for visual grouping
             (e.g. half rack → bench, bar, attachments). */
          indented: !!i.indented,
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Unit-toggle mode (per-piece ↔ per-sq-ft).
             Saved values already reflect the active mode; only flag is needed
             on load so the toggle button renders in the right state. */
          unitMode: i.unitMode || 'piece',
        };
        if (i.productHandle) obj.productHandle = i.productHandle;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Per-item external product link (custom
           manual-entry items). Persisted with the quote; the PDF reads it off
           the item instead of the shared per-SKU map. */
        if (i.externalLink) obj.externalLink = i.externalLink;
        if (!i.configured) {
          obj.configured = false;
          obj.pendingOptions = i.pendingOptions || null;
          obj.customOptions = i.customOptions || null;
        }
        return obj;
      }),
      fees: state.fees.map(function(f) {
        return { title: f.title, amount: f.amount || 0, status: f.status };
      }).concat(state.customFees.map(function(f) {
        return { title: f.title, amount: f.amount || 0, status: 'value' };
      })),
      tax: { mode: state.tax.mode, rate: state.tax.rate, amount: state.tax.amount, includeFreight: state.tax.includeFreight, includeInstallation: state.tax.includeInstallation },
      cardFee: { status: state.cardFee.status, amount: state.cardFee.amount },
      /* CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE (Ryan 2026-10-25, RW-1490) - whether the items moved since freight was quoted, so
         the job's OTHER versions can offer this one in their "Also request freight for" box (GET /family-freight `quoted`). */
      freight: Object.assign({}, state.freight, { itemsChanged: !!(Q.freightItemsChange && Q.freightItemsChange()) }),
      installation: state.installation,
      send: state.send,
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — PDF product-links toggle. */
      linkProductsOnPdf: !!state.linkProductsOnPdf,
      // ⚠ The server rebuilds workstation_meta FRESH from this payload on every save, so a field
      // that is not sent here is not merely unchanged — it is erased.
      vendorLabels: state.vendorLabels || {},
      /* CUSTOM_ROOMDESIGNER_BY_CLAUDE — append linked gym layout to the quote PDF
         + overage / wall-dimension render-variant choices. */
      includeLayoutInPdf: !!state.includeLayoutInPdf,
      layoutOverage: !!state.layoutOverage,
      layoutDimensions: !!state.layoutDimensions,
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Sales Rep override (admin ghost-author
         for printed PDF). Emit only when at least one field has content;
         otherwise emit null so the worker can clear a previously-saved
         override cleanly. */
      salesRepOverride: (state.salesRepOverride && (state.salesRepOverride.name || state.salesRepOverride.phone || state.salesRepOverride.email))
        ? {
            name: String(state.salesRepOverride.name || '').trim(),
            phone: String(state.salesRepOverride.phone || '').trim(),
            email: String(state.salesRepOverride.email || '').trim(),
          }
        : null,
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Existing credit (admin-applied
         deposit/credit on linked order). Emit null when amount is 0 so
         the worker can clear a previously-saved credit cleanly. */
      existingCredit: (state.existingCredit && (parseFloat(state.existingCredit.amount) || 0) > 0)
        ? {
            amount: Math.round((parseFloat(state.existingCredit.amount) || 0) * 100) / 100,
            sourceRef: String(state.existingCredit.sourceRef || '').trim().toUpperCase(),
          }
        : null,
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      leadSource: state.leadSource || null,
      // BLOCK A — Shared Deal recipient (PAID). Emitted only on a Shared Deal
      // with a name; the commission engine pays this person (shared band).
      referral: ((state.leadSource === 'shared') && state.referral && state.referral.name)
        ? { name: state.referral.name, gpPercent: parseFloat(state.referral.gpPercent) || 0 }
        : null,
      // BLOCK B ("Referred By") is retired — see the header comment. The server preserves any
      // existing wm.referralSource so historical values survive this save.
      cfaAttribution: state.cfaAttribution || 'none',
      // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-09) — manual "Repeat buyer" override.
      // Comp-neutral marker; the server also auto-detects prior SOLD deals by email/phone.
      // repeatBuyerOverride is intentionally NOT sent — the checkbox is retired, and omitting the
      // key makes handleSaveWorkstation's preserve branch keep any legacy `true` instead of
      // clearing it (it only nulls the value when the key is present and falsy).
      financials: {
        msrpTotal: Math.round(msrpTotal * 100) / 100,
        directTotal: Math.round(directTotal * 100) / 100,
        costTotal: Math.round(costTotal * 100) / 100,
        freightCost: Math.round(freightCost * 100) / 100,
        freightCharged: Math.round(freightCharged * 100) / 100,
        installCost: Math.round(installCost * 100) / 100,
        installCharged: Math.round(installCharged * 100) / 100,
        cardFee: Math.round(cardFeeAmt * 100) / 100,
        taxes: Math.round(taxAmt * 100) / 100,
        /* The two halves of Fees & Extras, kept apart. `feeDiscounts` is what every GP figure
           above is built from and what the worker rebuilds from; `feeCharges` is carried for the
           reader's sake — it is a pass-through and moves no profit number. */
        feeDiscounts: feeDiscounts,
        feeCharges: feeCharges,
        totalCosts: Math.round(totalCosts * 100) / 100,
        addOnProfit: Math.round(addOnProfit * 100) / 100,
        grossProfit: Math.round(grossProfit * 100) / 100,
        grossMargin: Math.round(grossMargin * 100) / 100,
        netProfit: Math.round(netProfit * 100) / 100,
        netMargin: Math.round(netMargin * 100) / 100,
        gpOfGoods: Math.round(gpOfGoods * 100) / 100,
        gpOfGoodsMargin: Math.round(gpOfGoodsMargin * 100) / 100,
        vendors: Object.keys(vendorMap)
      },
      pdfDownloaded: state.pdfDownloaded,
      eCleanerPromptedOnSave: !!state.eCleanerPromptedOnSave,
      eCleanerPromptedOnDownload: !!state.eCleanerPromptedOnDownload
    };
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-20) — saveDraft now RETURNS a
     promise resolving to { saved: bool, reason?: string }. It never rejects,
     so the existing fire-and-forget call sites (the Save button, the freight/
     install request flow in workstation-actions.js) are unaffected — they
     simply ignore the return value.

     Added so a caller can sequence work AFTER the save is durable. The freight
     "Apply to Quote" button needs this: it used to mutate local state and
     immediately fire the rep notification email, so an admin who applied but
     never clicked Save sent a "freight is ready" email for freight that was
     never persisted (JW-1234-B, 2026-07-20 — $452.14 emailed, server still
     read freight.status='requested'). */
  /* CUSTOM_PENDINGMATCH_BY_CLAUDE — resolves 'use' (state.ref now names the pending, so the
     save below converts it the same way the Deal Dashboard's "Create Quote" does), 'new' or
     'cancel'. GET /pending-match returns only the caller's own open pendings. */
  function askAboutOpenPending() {
    var c = Q.getCustomerData() || {};
    var qs = 'email=' + encodeURIComponent(c.email || '') + '&company=' + encodeURIComponent(c.company || '');
    var done = function(choice) { if (choice !== 'cancel') state.pendingMatchAsked = true; return choice; };
    return API.get('/pending-match?' + qs).then(function(data) {
      var matches = (data && data.matches) || [];
      if (!matches.length) return done('new');
      return new Promise(function(resolve) {
        var esc = function(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function(ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
        var day = function(iso) { var d = iso ? new Date(iso.length === 10 ? iso + 'T12:00:00' : iso) : null; return d && !isNaN(d) ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''; };
        var who = esc(matches[0].name || c.name || 'This customer');
        var old = wrap.querySelector('.rq-ws-dup-dialog');
        if (old) old.remove();
        var overlay = document.createElement('div');
        overlay.className = 'rq-ws-dup-dialog';
        overlay.innerHTML =
          '<div class="rq-ws-dup-dialog__card">' +
            '<div class="rq-ws-dup-dialog__title">' + who + (matches.length > 1 ? ' already has open pending deals' : ' already has an open pending deal') + '</div>' +
            '<div class="rq-ws-dup-dialog__product">' + matches.map(function(m) {
              return esc(m.ref) + (m.createdAt ? ', created ' + esc(day(m.createdAt)) : '') + (m.followUpAt ? ', reminder set for ' + esc(day(m.followUpAt)) : '');
            }).join('<br>') + '</div>' +
            '<div class="rq-ws-dup-dialog__buttons">' +
              matches.slice(0, 3).map(function(m) {
                return '<button class="rq-ws-dup-dialog__btn rq-ws-dup-dialog__btn--primary" data-action="use" data-ref="' + esc(m.ref) + '">Put this quote on ' + esc(m.ref) + '</button>';
              }).join('') +
              '<button class="rq-ws-dup-dialog__btn rq-ws-dup-dialog__btn--secondary" data-action="new">Start a new deal (keep the pending as it is)</button>' +
              '<button class="rq-ws-dup-dialog__btn rq-ws-dup-dialog__btn--cancel" data-action="cancel">Cancel</button>' +
            '</div>' +
          '</div>';
        overlay.addEventListener('click', function(e) {
          var action = e.target.getAttribute('data-action');
          if (!action && e.target === overlay) action = 'cancel';
          if (!action) return;
          overlay.remove();
          if (action === 'use') {
            state.ref = e.target.getAttribute('data-ref');
            state.mode = 'edit';
          }
          resolve(done(action));
        });
        wrap.appendChild(overlay);
      });
    }).catch(function() { return done('new'); });
  }

  function saveDraft(btn) {
    var errors = validateRequired();
    if (errors.length) {
      showToast(errors.join('\n'), 'error');
      return Promise.resolve({ saved: false, reason: 'validation' });
    }

    /* CUSTOM_PENDINGMATCH_BY_CLAUDE (Ryan 2026-10-27) — the FIRST save of a brand-new deal asks
       whether this customer's open pending should take the quote. "Start a new deal" leaves the
       pending exactly as it is (Ryan: a kept pending is a standing call-them-again reminder, bell
       and all). Asked once per deal; a failed lookup saves as before rather than blocking. */
    if (!state.ref && !state.pendingMatchAsked) {
      return askAboutOpenPending().then(function(choice) {
        if (choice === 'cancel') return { saved: false, reason: 'cancelled' };
        return saveDraft(btn);
      });
    }

    var origText = btn.textContent;
    btn.textContent = 'Saving...';
    btn.disabled = true;

    // No items AND no Shopify draft yet → save as a pending draft (KV only).
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-05) — guard on !state.draftOrderId.
       A quote built FROM A LEAD (/create-quote-from-lead) already has a real,
       ref-tagged Shopify draft + workstation_meta but NO pending: record. Routing
       its 0-item save to /update-pending-full looked up pending:{ref}, found
       nothing, and threw "Pending quote not found" (reported on RW-1179-A). A
       draft-backed quote (draftOrderId set) must save via /save-workstation even
       with 0 line items; only a truly from-scratch quote uses the pending path. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-29) — also skip the pending path
       when grand total > $0 (e.g. installation-only or freight-only quote). The
       pending path only persists customer info — fees would be silently lost.
       When there's real monetary value, route to /save-workstation so a Shopify
       draft is created with the fee line items. */
    if (state.items.length === 0 && !state.draftOrderId && !(state.lastGrandTotal > 0)) {
      var customer = Q.getCustomerData();
      // If already a pending quote, update it instead of creating a new one
      if (state.ref) {
        var updatePayload = { ref: state.ref, note: '', customerFull: customer, name: customer.name, email: customer.email, phone: customer.phone, organization: customer.company, street: customer.street, street2: customer.street2, city: customer.city, state: customer.state, zip: customer.zip, attn: customer.attn };
        return API.post('/update-pending-full', updatePayload).then(function(data) {
          state.dirty = false;
          document.dispatchEvent(new Event('rq-ws:saved'));
          btn.textContent = 'Saved!';
          setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
          return { saved: true };
        }).catch(function(err) {
          btn.textContent = origText; btn.disabled = false;
          showToast('Save failed: ' + (err.message || 'Unknown error'), 'error');
          return { saved: false, reason: err.message || 'error' };
        });
      }
      var pendingPayload = {
        name: customer.name,
        email: customer.email,
        phone: customer.phone,
        organization: customer.company,
        street: customer.street,
        street2: customer.street2,
        city: customer.city,
        state: customer.state,
        zip: customer.zip,
        attn: customer.attn,
        note: '',
        customerFull: customer,
      };
      return API.post('/create-pending', pendingPayload).then(function(data) {
        if (data.ref) {
          state.ref = data.ref;
          state.mode = 'edit';
          state.dirty = false;
          document.dispatchEvent(new Event('rq-ws:saved'));
          dom.barRef.textContent = data.ref;
          Q.updateBarCustomer();
          Q.setStatusBadge('saved');
          Q.updateFeeDropdownOptions();
          if (window.history.replaceState) {
            window.history.replaceState(null, '', window.location.pathname + '?ref=' + encodeURIComponent(data.ref));
          }
          state.quotesCache = null;
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — this deal did not exist when the Deal
             Dashboard last cached its board, and that cache is sessionStorage: per-tab, and it
             SURVIVES the navigation the rep is about to make. Without this, saving a pending here
             and clicking through to the DD shows a list assembled before the save — the same
             "I have to refresh to see it" Ryan hit on the DD's own + New Pending. */
          try {
            if (window.RepPortal && window.RepPortal.API && window.RepPortal.API.invalidateDealList) {
              window.RepPortal.API.invalidateDealList();
            }
          } catch (_e) { /* best-effort — the DD's own mutation flag still bypasses the server cache */ }
        }
        btn.textContent = 'Saved as Pending!';
        setTimeout(function() { btn.textContent = origText; btn.disabled = false; updateSaveButton(); }, 2000);
        return { saved: true };
      }).catch(function(err) {
        btn.textContent = origText;
        btn.disabled = false;
        showToast('Save failed: ' + (err.message || 'Unknown error'), 'error');
        return { saved: false, reason: err.message || 'error' };
      });
    }

    var payload = buildSavePayload();
    return API.post('/save-workstation', payload).then(function(data) {
      showFreightSaveNotices(data); // CUSTOM_FREIGHTSAVEMERGE_BY_CLAUDE
      if (data.ref) {
        takeOfflineTax(data); // CUSTOM_OFFLINETAXROW_BY_CLAUDE
        state.ref = data.ref;
        state.mode = 'edit';
        state.dirty = false;
        state.loadedGrandTotal = state.lastGrandTotal;
        document.dispatchEvent(new Event('rq-ws:saved'));
        state.draftOrderId = data.draftOrderId || state.draftOrderId;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Push both referral names to the shared
           memory so they autocomplete next time here AND on the Quote
           Dashboard's +New lead form. BLOCK A only (Shared Deal recipient) —
           BLOCK B was retired 2026-07-24 with the Lead Source dropdown. */
        if (state.leadSource === 'shared' && state.referral && state.referral.name) {
          pushReferralToMemory(state.referral.name, state.referral.gpPercent);
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        dom.barRef.textContent = data.ref;
          Q.updateBarCustomer();
        Q.setStatusBadge('saved');
        Q.updateFeeDropdownOptions();
        if (dom.btnNew) dom.btnNew.classList.remove('rq-ws-bar__btn--active');
        dom.btnLoad.classList.add('rq-ws-bar__btn--active');

        // Update URL
        if (window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + '?ref=' + encodeURIComponent(data.ref));
        }

        // Invalidate cache
        state.quotesCache = null;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Remember this rep for next time.
           Upsert into localStorage keyed by lowercase name. Only fires
           when the override has a non-empty name; clearing the override
           shouldn't wipe the saved entry (admin may still want to re-use
           that rep on a future quote). */
        if (Q.salesRepMemoryUpsert && state.salesRepOverride && state.salesRepOverride.name) {
          Q.salesRepMemoryUpsert(state.salesRepOverride);
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }
      btn.textContent = 'Saved!';
      setTimeout(function() { btn.textContent = origText; btn.disabled = false; updateSaveButton(); }, 2000);
      return { saved: true };
    }).catch(function(err) {
      btn.textContent = origText;
      btn.disabled = false;
      showToast('Save failed: ' + (err.message || 'Unknown error'), 'error');
      return { saved: false, reason: err.message || 'error' };
    });
  }

  /* CUSTOM_FREIGHTSAVEMERGE_BY_CLAUDE (ONYX 44a20f69e2a7 + n1, Ryan 2026-10-16) - what the save did to freight, said to the rep.
     (1) `freightKept`: freight was applied to this quote (by an agent or a colleague) after this screen was opened; the save
     kept it on the quote instead of saving it away. (2) `freightRequestCancelled`: the save changed the items or quantities,
     the delivery options or the ship-to ZIP / state under a freight request still waiting for its rate, so that request was
     cancelled and freight must be requested again. Never on a Save As (its new version has no request). */
  function showFreightSaveNotices(data) {
    if (!data) return;
    /* CUSTOM_QWALERTS_BY_CLAUDE (Ryan 2026-10-23, Pass 2) - both notices are rows in the alerts banner (they were 12-15 second
       toasts that could vanish before anyone read them); the toast stays only as the fallback. */
    if (data.freightKept && Q.showAlert) {
      var _who = data.freightKept.appliedBy ? ' by ' + data.freightKept.appliedBy : '';
      Q.showAlert({ id: 'freight-kept', level: 'orange', icon: '&#x1F69A;', persist: false, quoteScoped: true,
        head: 'Freight was added while you had this open',
        text: 'Freight was added' + _who + ' after you opened the quote, so it was kept ($' + (Number(data.freightKept.charged) || 0).toFixed(2) + '). Your other changes were saved. Reload to see it here.',
        action: { label: 'Reload', run: function () { if (Q.loadQuote && state.ref) Q.loadQuote(state.ref); } } });
    } else if (data.freightKept) {
      var who = data.freightKept.appliedBy ? ' by ' + data.freightKept.appliedBy : '';
      showToast('Freight was added to this quote' + who + ' after you opened it, so it was kept on the quote ($'
        + (Number(data.freightKept.charged) || 0).toFixed(2) + '). Your other changes were saved. Reload the quote to see the freight here.', 'warning', 12000);
    }
    var rc = data.freightRequestCancelled;
    if (rc) {
      var what = (rc.changed && rc.changed.length) ? rc.changed.join(', ') : 'the quote';
      if (rc.cancelled && Q.showAlert) {
        if (state.freight) { state.freight.status = 'pending'; state.freight.requestedAt = null; state.freight.requestedBy = null; }
        if (Q.updateRequestButton) Q.updateRequestButton();
        Q.showAlert({ id: 'freight-request-cancelled', level: 'red', icon: '&#x1F69A;', persist: false, quoteScoped: true,
          head: 'Freight request cancelled',
          text: 'You changed the ' + what + ', so the waiting freight request was cancelled. Request freight again so the rate matches this quote.',
          action: { label: 'Request again', run: function () { if (Q.hideAlert) Q.hideAlert('freight-request-cancelled'); if (Q.requestFreightNow) Q.requestFreightNow(); } } });
      } else if (!rc.cancelled && Q.showAlert) {
        Q.showAlert({ id: 'freight-request-cancelled', level: 'red', icon: '&#x1F69A;', persist: false, quoteScoped: true,
          head: 'Freight request could not be cancelled',
          text: 'You changed the ' + what + ' while a freight request is waiting, but it could not be cancelled (' + (rc.error || 'unknown') + '). Cancel it from the Deal Dashboard and request freight again.' });
      } else if (rc.cancelled) {
        if (state.freight) { state.freight.status = 'pending'; state.freight.requestedAt = null; state.freight.requestedBy = null; }
        if (Q.updateRequestButton) Q.updateRequestButton();
        showToast('The freight request was cancelled because you changed the ' + what + '.\nRequest freight again so the rate matches this quote.', 'warning', 15000);
      } else {
        showToast('You changed the ' + what + ' while a freight request is waiting, but the request could not be cancelled (' + (rc.error || 'unknown') + ').\nCancel it from the Deal Dashboard and request freight again.', 'error', 15000);
      }
    }
  }
  /* END CUSTOM_FREIGHTSAVEMERGE_BY_CLAUDE */

  function saveAsDraft(btn, keepLayout) {
    var errors = validateRequired();
    if (errors.length) { showToast(errors.join('\n'), 'error'); return; }
    if (!state.ref) { saveDraft(btn); return; }

    var origText = btn.textContent;
    btn.textContent = 'Saving new version...';
    btn.disabled = true;

    var origRef = state.ref;
    var origDraftOrderId = state.draftOrderId;

    /* CUSTOM_QUOTELAYOUTCOPY_BY_CLAUDE (Ryan 2026-10-10) — the Save As question's answer: the new version gets
       its own copy of the gym layout. Never on a designer hand-off (pendingLinkDesign), which links the design itself. */
    var _keepLayout = !!(keepLayout && _floorPlanOf(state.linkedFiles) && !state.pendingLinkDesign);
    API.post('/clone-quote', { ref: state.ref, keepLayout: _keepLayout }).then(function(data) {
      if (!data.ref) throw new Error('Clone returned no ref');
      var newRef = data.ref;
      var _ly = data.layout || null;
      if (_ly && _ly.copied) {
        state.linkedFiles = (Array.isArray(state.linkedFiles) ? state.linkedFiles : []).filter(function(f) { return !(f && f.type === 'floor-plan'); })
          .concat([{ type: 'floor-plan', designId: _ly.designId, designRef: _ly.designRef }]);
      } else if (_floorPlanOf(state.linkedFiles) && !state.pendingLinkDesign) {
        /* Not copied (box unticked, or the copy failed): the new version has no layout, so its boxes go off. */
        state.linkedFiles = state.linkedFiles.filter(function(f) { return !(f && f.type === 'floor-plan'); });
        state.includeLayoutInPdf = false; state.layoutOverage = false; state.layoutDimensions = false;
        if (_keepLayout && _ly && _ly.why) showToast('The gym layout was not copied to ' + newRef + ' (' + _ly.why + ').', 'warning');
      }
      state.ref = newRef;
      // Must null draftOrderId so the worker doesn't reuse the source revision's
      // draft order. With the GID still set, /save-workstation finds the old draft
      // by direct lookup and updates it in place — silently overwriting the source
      // revision's tag and stripping it from the dashboard chain.
      state.draftOrderId = null;
      state.pdfDownloaded = false;
      // A new revision is a new quote — reset the E-Cleaner prompt flags so
      // the rep gets the nudge on the new ref's first save and first download.
      state.eCleanerPromptedOnSave = false;
      state.eCleanerPromptedOnDownload = false;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Existing credit doesn't carry through
         to a clone. The credit represents money already collected on a
         parent quote (or earned elsewhere); claiming the same credit on
         two revisions would double-apply it against a single deposit. If
         the admin needs the credit on the new revision too, they re-enter
         it explicitly — safer default than silently propagating. */
      var _hadCredit = state.existingCredit && parseFloat(state.existingCredit.amount) > 0;
      if (_hadCredit) {
        state.existingCredit = { amount: 0, sourceRef: '' };
        var _ecA = wrap.querySelector('[data-field="existingCreditAmount"]');
        var _ecS = wrap.querySelector('[data-field="existingCreditSourceRef"]');
        if (_ecA) _ecA.value = '';
        if (_ecS) _ecS.value = '';
        if (Q.recalcTotals) Q.recalcTotals();
        showToast('Existing credit cleared on new revision — re-enter if it still applies.', 'warning');
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_REVISIONFREIGHTREQ_BY_CLAUDE (ONYX fd42c31c58ef, Ryan 2026-10-10, RW-1379-B/-C) - a freight or installation
         REQUEST belongs to the version it was made on. Copied onto -B it showed "Freight requested on 10/10" before anyone
         clicked, and the first save fired the parent's request again (note, orders@ copy, the agent's freight-quote row,
         all dated the parent's request). A quoted figure still carries over: only the open request resets, the way the
         "Re-request Freight Quote" button resets it. */
      if (state.freight && state.freight.status === 'requested') {
        state.freight.status = 'pending';
        state.freight.requestedAt = null;
        state.freight.requestedBy = null;
      }
      if (state.installation && state.installation.status === 'requested') {
        state.installation.status = 'pending';
        state.installation.requestedAt = null;
        state.installation.requestedBy = null;
      }
      if (Q.updateRequestButton) Q.updateRequestButton();
      /* END CUSTOM_REVISIONFREIGHTREQ_BY_CLAUDE */
      var payload = buildSavePayload();
      return API.post('/save-workstation', payload).then(function(saveData) {
        return { ref: newRef, draftOrderId: saveData.draftOrderId, offlineTax: saveData.offlineTax || null };
      });
    }).then(function(result) {
      takeOfflineTax(result); // CUSTOM_OFFLINETAXROW_BY_CLAUDE
      state.ref = result.ref;
      state.mode = 'edit';
      state.dirty = false;
      state.draftOrderId = result.draftOrderId || state.draftOrderId;
      state.loadedGrandTotal = state.lastGrandTotal;
      /* CUSTOM_ROOMDESIGNER_BY_CLAUDE — Clear RD Mode 2 pending-revision intent; subsequent saves are normal */
      state.pendingRevisionBase = null;
      state.pendingRevisionNext = null;

      document.dispatchEvent(new Event('rq-ws:saved'));
      dom.barRef.textContent = state.ref;
          Q.updateBarCustomer();
      Q.setStatusBadge('saved');
      if (dom.btnNew) dom.btnNew.classList.remove('rq-ws-bar__btn--active');
      dom.btnLoad.classList.add('rq-ws-bar__btn--active');
      if (window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + '?ref=' + encodeURIComponent(state.ref));
      }
      state.quotesCache = null;

      if (Q.refreshLayoutPdfToggle) Q.refreshLayoutPdfToggle();   // CUSTOM_QUOTELAYOUTCOPY_BY_CLAUDE
      btn.textContent = 'Saved as ' + state.ref;
      setTimeout(function() { btn.textContent = origText; btn.disabled = false; updateSaveButton(); }, 2500);
    }).catch(function(err) {
      state.ref = origRef;
      state.draftOrderId = origDraftOrderId;
      btn.textContent = origText;
      btn.disabled = false;
      showToast('Save As failed: ' + (err.message || 'Unknown error'), 'error');
    });
  }

  /* ── Preview PDF ── */
  wrap.querySelector('.rq-ws-send__preview').addEventListener('click', function() {
    // Always save before previewing to ensure PDF has latest data
    var self = this;
    var errors = validateRequired();
    if (errors.length) { showToast(errors.join('\n'), 'error'); return; }

    // Check for incomplete line items (missing cost, MSRP, etc.)
    Q.validateAllRows();
    if (Q.hasValidationErrors()) {
      showToast('Some line items have missing fields (highlighted in red). Please fill them in before previewing.', 'error');
      return;
    }

    function proceedToSaveAndDownload() {
      self.textContent = 'Saving...';
      self.disabled = true;
      var payload = buildSavePayload();
      API.post('/save-workstation', payload).then(function(data) {
        showFreightSaveNotices(data); // CUSTOM_FREIGHTSAVEMERGE_BY_CLAUDE
        if (data.ref) {
          takeOfflineTax(data); // CUSTOM_OFFLINETAXROW_BY_CLAUDE
          state.ref = data.ref;
          state.mode = 'edit';
          state.draftOrderId = data.draftOrderId || '';
          state.loadedGrandTotal = state.lastGrandTotal;
          dom.barRef.textContent = data.ref;
            Q.updateBarCustomer();
          Q.setStatusBadge('saved');
          if (window.history.replaceState) {
            window.history.replaceState(null, '', window.location.pathname + '?ref=' + encodeURIComponent(data.ref));
          }
        }
        state.pdfDownloaded = true;
        self.textContent = 'Download PDF';
        self.disabled = false;
        updateSaveButton();
        openPdfPreview();
      }).catch(function(err) {
        self.textContent = 'Download PDF';
        self.disabled = false;
        showToast('Save failed: ' + (err.message || 'Unknown error'), 'error');
      });
    }

    // One last chance to add E-Cleaner before the customer-facing send.
    // Once-per-quote — if the rep already saw it on download, skip.
    checkLayoutBeforePdf(function() {   // CUSTOM_QUOTELAYOUTSWAP_BY_CLAUDE
      if (Q.maybePromptECleaner && Q.maybePromptECleaner('download', proceedToSaveAndDownload)) return;
      proceedToSaveAndDownload();
    });
  });

  function openPdfPreview() {
    var email = wrap.querySelector('[data-field="email"]').value.trim();
    var sess = JSON.parse(sessionStorage.getItem('rep_portal_session') || '{}');
    // Pass the JWT in the URL so the worker can validate and verify quote ownership.
    // The previous `&repCode=` flow was an auth bypass — anyone with a valid rep code
    // could pull any PDF by guessing refs. The JWT is short-lived; URL-leak surface
    // is acceptable for the new-tab/download flow.
    var token = sess.accessToken || '';
    var url = 'https://rfq-worker.ryan-29b.workers.dev/pdf?ref=' + encodeURIComponent(state.ref) + '&email=' + encodeURIComponent(email) + '&token=' + encodeURIComponent(token);
    if (state.draftOrderId) url += '&id=' + encodeURIComponent(state.draftOrderId);
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-09) — preview in a tab AND download the
       PDF with a guaranteed-correct filename. Previously this just window.open'd the /pdf
       URL and left the SAVE to Chrome's inline PDF viewer, which intermittently percent-
       encodes the Content-Disposition spaces ("%20") then sanitizes "%"→"_", producing
       "RW-1239-A_20-_20Aaron...". Fix: fetch the PDF ONCE (so the /pdf side-effects —
       pdfDownloaded / lifecycle / follow-up — fire exactly once, same as before), point a
       reserved tab at the blob for preview, and trigger a blob download whose name WE set
       (Chrome never gets to guess). Reserve the tab synchronously first so the popup
       blocker doesn't eat it after the fetch. Falls back to the old direct-URL preview on
       any fetch error. */
    var previewTab = window.open('', '_blank');
    fetch(url, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        var cd = r.headers.get('Content-Disposition') || '';
        var m = /filename\*?=\s*(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
        var name = state.ref + '.pdf';
        if (m && m[1]) { try { name = decodeURIComponent(m[1].trim()); } catch (e) { name = m[1].trim(); } }
        return r.blob().then(function(blob) { return { blob: blob, name: name }; });
      })
      .then(function(res) {
        // Authoritative, correctly-named download — Chrome never guesses the name.
        var blobUrl = URL.createObjectURL(res.blob);
        var a = document.createElement('a');
        a.href = blobUrl; a.download = res.name;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        setTimeout(function() { URL.revokeObjectURL(blobUrl); }, 5000);
        // Point the reserved tab at the /pdf URL in PREVIEW mode: no download side-effects,
        // and the server's filename* names the tab's own Save correctly. (A blob: URL would
        // save as its opaque UUID — that was the b033b2... bug.)
        var previewUrl = url + '&preview=1';
        if (previewTab) { try { previewTab.location = previewUrl; } catch (e) { window.open(previewUrl, '_blank'); } }
      })
      .catch(function() {
        if (previewTab) { try { previewTab.location = url; } catch (e) {} } else { window.open(url, '_blank'); }
      });
  }

  /* ── Send Quote ── */
  var _sendLayoutPass = false;
  wrap.querySelector('.rq-ws-send__send').addEventListener('click', function() {
    var totalChanged = state.loadedGrandTotal !== null && state.ref && state.lastGrandTotal !== state.loadedGrandTotal && state.pdfDownloaded;
    if (totalChanged) {
      showToast('The total has changed. Use "Save As" to create a new version before sending.', 'error');
      return;
    }
    var errors = validateRequired();
    if (errors.length) { showToast(errors.join('\n'), 'error'); return; }

    // Check for incomplete line items
    Q.validateAllRows();
    if (Q.hasValidationErrors()) {
      showToast('Some line items have missing fields (highlighted in red). Please fill them in before sending.', 'error');
      return;
    }

    // NEW Send Quote flow (Ryan 2026-05-30): instead of the old Resend branded
    // email (/send-quote → status page), open the SAME Outlook composer the Deal
    // Dashboard uses. The freshly-generated quote PDF is auto-attached. The rep
    // picks Reply-on-existing-thread or New-email; on a successful Outlook send
    // we mark the quote sent (stamp wm flags + deal-feed event via /quote-mark-sent).
    if (!window.RQD || typeof window.RQD.openComposeModal !== 'function') {
      showToast('Email composer failed to load — refresh and try again.', 'error');
      return;
    }

    /* CUSTOM_SENDFREIGHTCHECK_BY_CLAUDE - see askFreightBeforeSend */
    var _fch = Q.freightItemsChange ? Q.freightItemsChange() : null;
    if (_fch && (_fch.copied || _freightSendOk !== _fch.sig)) {
      var _self = this;
      askFreightBeforeSend(_fch, function() { _freightSendOk = _fch.sig; _self.click(); });
      return;
    }
    /* CUSTOM_QUOTELAYOUTSWAP_BY_CLAUDE - see checkLayoutBeforePdf. The re-click carries a one-shot pass. */
    if (!_sendLayoutPass) {
      var _sendBtn = this;
      checkLayoutBeforePdf(function() { _sendLayoutPass = true; _sendBtn.click(); });
      return;
    }
    _sendLayoutPass = false;

    var btn = this;
    var origText = btn.textContent;
    if (window.RQD && window.RQD.restoreMinimizedCompose && window.RQD.restoreMinimizedCompose(state.ref)) return;   // CUSTOM_COMPOSEDRAFT_BY_CLAUDE
    btn.textContent = 'Preparing…';
    btn.disabled = true;

    function _resetBtn() { btn.textContent = origText; btn.disabled = false; }

    // onSent fires once after a successful Outlook send (new OR reply). Marks the
    // quote sent server-side, clears dirty state, flips the status badge.
    var onSent = Q.markQuoteSentFromComposer;

    // Step 1: save so the PDF reflects the latest data (mirrors Download-PDF save).
    var payload = buildSavePayload();
    API.post('/save-workstation', payload).then(function(data) {
      showFreightSaveNotices(data); // CUSTOM_FREIGHTSAVEMERGE_BY_CLAUDE
      if (data.ref) {
        takeOfflineTax(data); // CUSTOM_OFFLINETAXROW_BY_CLAUDE
        state.ref = data.ref;
        state.mode = 'edit';
        state.draftOrderId = data.draftOrderId || state.draftOrderId;
        dom.barRef.textContent = data.ref;
        Q.updateBarCustomer();
      }

      var _custData = Q.getCustomerData();
      var customerEmail = _custData.email || '';
      var customerName = (_custData.name || '').trim();

      // Step 2: fetch the freshly-generated PDF + convert to base64 so it can be
      // pre-attached. Non-blocking: on failure we still open the composer (no PDF).
      function fetchPdfAttachment() {
        var sess = JSON.parse(sessionStorage.getItem('rep_portal_session') || '{}');
        var token = sess.accessToken || '';
        var pdfUrl = 'https://rfq-worker.ryan-29b.workers.dev/pdf?ref=' + encodeURIComponent(state.ref)
          + '&email=' + encodeURIComponent(customerEmail) + '&token=' + encodeURIComponent(token) + '&attach=1'; // CUSTOM_QUOTESENTCLOCK_BY_CLAUDE - attaching is not sending
        if (state.draftOrderId) pdfUrl += '&id=' + encodeURIComponent(state.draftOrderId);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — one fetcher, the composer's.

           This used to be its own fetch + FileReader here, written long before email snippets
           existed. It read Content-Disposition for the filename and nothing else — so the PDF it
           pre-attached carried no `quoteMeta`, and the ordering-instructions snippet refused with
           *"attach the quote first, so the page number comes from the PDF you are actually
           sending"* at a rep whose quote was already sitting in the composer.

           ⛔ The DUPLICATE was the bug, not a missing line. RQD.fetchDealPdfAttachment does the
           same Content-Disposition read this did (so the descriptive "REF - Customer - DATE.pdf"
           name is unchanged) AND stamps the X-BSF-* ordering page, total, payment kind and
           payment link. Calling it means the QW can never again fall behind what the DD's
           attachments know about themselves.

           Still non-blocking: on any failure the composer opens with no PDF, as before. */
        if (!window.RQD || typeof window.RQD.fetchDealPdfAttachment !== 'function') {
          showToast('Could not attach the PDF automatically — you can add it manually.', 'warning');
          return Promise.resolve(null);
        }
        return window.RQD.fetchDealPdfAttachment(pdfUrl, token, state.ref + '.pdf', 'application/pdf', state.ref)
          .catch(function() {
            showToast('Could not attach the PDF automatically — you can add it manually.', 'warning');
            return null;
          });
      }

      return fetchPdfAttachment().then(function(pdfAtt) {
        // Step 3: does this deal already have an email thread? (reply-vs-new)
        // siblings=1 — the customer's OTHER deals too (AIOPS c811b43f9288)
        return API.get('/deal-email-thread?siblings=1&search=1&ref=' + encodeURIComponent(state.ref))  // search=1: no thread on the deal -> the worker looks in Outlook for the customer's mail first (CUSTOM_SENDQUOTEPULL_BY_CLAUDE, RW-1509-A)
          .catch(function() { return { emails: [] }; })
          .then(function(thread) {
            _resetBtn();
            var emails = (thread && Array.isArray(thread.emails)) ? thread.emails : [];
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (AIOPS c811b43f9288, Ryan 2026-09-28) — `emails` now spans the
               customer's other deals too, so it can hold several conversations. Grouped once; the
               chooser picks one (newest by default) and the reply fork opens on it. */
            var threads = (window.RQD && typeof window.RQD.groupEmailThreads === 'function')
              ? window.RQD.groupEmailThreads(emails)
              : (emails.length ? [{ top: emails[0], emails: emails, label: '' }] : []);
            var preAtt = pdfAtt ? [pdfAtt] : [];

            function openNew() {
              window.RQD.openComposeModal({
                ref: state.ref,
                persistMinimized: true,   // CUSTOM_COMPOSEDRAFT_BY_CLAUDE
                prefillTo: customerEmail,
                dealCustomer: { name: _custData.name, email: _custData.email, contacts: _custData.contacts }, // CUSTOM_DEALPEOPLE_BY_CLAUDE - the To / CC people
                prefillSubject: (customerName ? 'Quote for ' + customerName + ' - ' : 'Quote - ') + 'Blue Sky Fitness Supply - ' + state.ref,
                preAttachments: preAtt,
                // From: selector — quote can send from you or Abby (sends via /outlook-send).
                emailType: 'quote-send',
                /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — the QW half of the same rule:
                   *"rep emails when they click the 'Email' button in the DD or QW will always be
                   from them. admins default to from them, but they can choose."* A rep emailing
                   their own quote to their own customer signs it themselves; one option renders
                   as a locked From row. `forceFrom` opens an admin on themselves even if they
                   once picked Abby here, and their override stays a one-off rather than becoming
                   the new default. The REPLY fork below was already locked to REP — a reply rides
                   the owner's own thread — so the two forks now agree. */
                forceFrom: 'REP',
                fromOptions: isAdmin ? ['REP', 'ABBY'] : ['REP'],
                /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-08-20) — the ⏱ clock on the toolbar.
                   ⛔ DEFAULT UNCHECKED HERE, unlike every other composer that has this control.
                   Those are all Abby/system emails composed on somebody's behalf at an arbitrary
                   moment, where holding to business hours is obviously right. This is a rep TYPING
                   RIGHT NOW and pressing Send because they mean now — defaulting to a hold would
                   mean the first person to email a customer at 8pm finds out the next morning.
                   Ticking it is the deliberate act. */
                showBusinessHours: true,
                businessHoursDefault: false,
                onSent: onSent,
              });
            }
            /* CUSTOM_COMPOSEDRAFT_BY_CLAUDE (Ryan 2026-10-10) — the "Reply on existing thread / New email" pop-up is
               gone: with a thread the composer opens replying on the newest one, and its own boxes switch to a new
               email (subject swapped to the quote's) and its picker to another thread. */
            function otherPartyOf(tEmails) {
              for (var ei = 0; ei < tEmails.length; ei++) {
                var em = tEmails[ei];
                if (em && em.direction === 'inbound') return em.fromName || em.from || '';
              }
              return customerEmail;
            }
            var threadChoices = threads.map(function(t, i) {
              var _r = (t.top && t.top.replyAll) || null;
              return {
                label: t.label || ((t.top && t.top.subject) || ('Thread ' + (i + 1))),
                messageId: t.top && t.top.messageId,
                subject: (t.top && t.top.subject) || '',
                to: (_r && _r.to && _r.to.length) ? _r.to.slice() : [customerEmail].filter(Boolean),
                cc: (_r && Array.isArray(_r.cc)) ? _r.cc.slice() : [],
                withWhom: otherPartyOf(t.emails || []),
                emails: t.emails || [],
              };
            });
            function openReply(threadIdx) {
              var picked = threads[threadIdx || 0] || threads[0];
              var top = picked.top;
              var tEmails = picked.emails;
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-30) — pass the thread
                 context + entries so the composer can show WHICH thread the rep
                 is replying to (original subject + other party) and render the
                 prior emails in a scrollable preview panel. replyThread/
                 replyContext are optional ctx fields — DD callers pass neither,
                 so their compose flow is unaffected. */
              var otherParty = '';
              for (var ei = 0; ei < tEmails.length; ei++) {
                var em = tEmails[ei];
                if (em && em.direction === 'inbound') {
                  otherParty = em.fromName || em.from || '';
                  break;
                }
              }
              if (!otherParty) otherParty = customerEmail;
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — open on REPLY-ALL, addressed the way
                 the send would address it. Ryan: *"automatically reply all to that email whether it
                 be me replying to my own last email which also goes to the customer, or me replying
                 directly to the customer."*

                 `top.replyAll` is built by /deal-email-thread, not here, because the audience needs
                 the system-mailbox list and that lives in KV — see the note over `_replyAudience`
                 there. It is already reply-all minus our own mailboxes, with the customer forced
                 into To. Chips, so the rep sees the audience and can edit it before sending.

                 ⚠️ `customerEmail` stays as the fallback for a thread row that predates the field. */
              var _ra = top.replyAll || null;
              var _toPrefill = (_ra && _ra.to && _ra.to.length) ? _ra.to.join(', ') : customerEmail;
              window.RQD.openComposeModal({
                ref: state.ref,
                persistMinimized: true,   // CUSTOM_COMPOSEDRAFT_BY_CLAUDE
                prefillTo: _toPrefill,
                prefillCc: (_ra && Array.isArray(_ra.cc)) ? _ra.cc.slice() : [],
                replyToMessageId: top.messageId,
                // Composer's send guard requires a non-empty subject; seed the
                // thread subject so the rep can keep/edit it (server keeps thread
                // subject intact on /outlook-reply regardless).
                prefillSubject: top.subject || ('Your Blue Sky Fitness Supply Quote — ' + state.ref),
                preAttachments: preAtt,
                // Reply stays on the existing thread (owner's mailbox), so sender is locked.
                fromOptions: ['REP'],
                /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-08-20) — the ⏱ clock on the toolbar.
                   ⛔ DEFAULT UNCHECKED HERE, unlike every other composer that has this control.
                   Those are all Abby/system emails composed on somebody's behalf at an arbitrary
                   moment, where holding to business hours is obviously right. This is a rep TYPING
                   RIGHT NOW and pressing Send because they mean now — defaulting to a hold would
                   mean the first person to email a customer at 8pm finds out the next morning.
                   Ticking it is the deliberate act. */
                showBusinessHours: true,
                businessHoursDefault: false,
                onSent: onSent,
                replyThread: tEmails,
                threadChoices: threadChoices,
                threadIndex: threadIdx || 0,
                newModeSubject: (customerName ? 'Quote for ' + customerName + ' - ' : 'Quote - ') + 'Blue Sky Fitness Supply - ' + state.ref,
                replyContext: {
                  subject: top.subject || '',
                  withWhom: otherParty,
                  count: tEmails.length,
                },
              });
            }

            if (threads.length) openReply(0); else openNew();
          });
      });
    }).catch(function(err) {
      _resetBtn();
      showToast('Send failed: ' + (err.message || 'Unknown error'), 'error');
    });
  });

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-30) — refresh the Send-button
     gate whenever the quote saves or items change (add/remove a row also
     dispatches rq-ws:saved-adjacent flows that route through recalcTotals →
     updateSaveButton, but listen here too as a belt-and-suspenders so Send
     never gets stuck grayed after an item change). Also run once on boot to
     clear the section's hardcoded inline disabled style for valid quotes. */
  document.addEventListener('rq-ws:saved', updateSendButton);
  /* CUSTOM_RFQPORTAL_BY_CLAUDE — recalcTotals (workstation-totals.js) runs on
     every item add/remove/qty/price change. We can't edit that file, so wrap
     its exported fn additively to also refresh the Send-button gate. Idempotent
     guard prevents double-wrapping if this module ever re-runs. */
  if (Q.recalcTotals && !Q.recalcTotals._sendBtnWrapped) {
    var _origRecalcTotals = Q.recalcTotals;
    var _wrappedRecalcTotals = function() {
      var r = _origRecalcTotals.apply(this, arguments);
      try { updateSendButton(); } catch (_) {}
      return r;
    };
    _wrappedRecalcTotals._sendBtnWrapped = true;
    Q.recalcTotals = _wrappedRecalcTotals;
  }
  updateSendButton();

  /* ── Exports ── */
  Q.saveDraft = saveDraft;
  Q.saveAsDraft = saveAsDraft;
  Q.updateSaveButton = updateSaveButton;
  Q.updateSendButton = updateSendButton;
  Q.validateRequired = validateRequired;
  Q.buildSavePayload = buildSavePayload;
  Q.fetchEmailSentLog = Q.fetchEmailSentLog || function() {}; // provided by freight module
})();
